import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import "../Companies/Companies.css";
import Header from "../Header/Header";
import SidebarFilter from "../Companies/SidebarFilter";
import { FaPlus } from "react-icons/fa6";
import { FaLinkedin } from "react-icons/fa";
import { MdClose } from "react-icons/md";
import { VscPass } from "react-icons/vsc";
import { VscError } from "react-icons/vsc";
import * as XLSX from "xlsx";
import { IoMdDownload } from "react-icons/io";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { GiCampfire } from "react-icons/gi";
import { MdDelete } from "react-icons/md";
import { MdOutlineMailOutline } from "react-icons/md";
import Swal from "sweetalert2";
import { IoLockOpen } from "react-icons/io5";
import EmptyImage from "../../assets/Images/no-image.png";
import { IoMdLink } from "react-icons/io";
import mail from "../../assets/Images/mail.png";
import download from "../../assets/Images/download.png";
import cross from "../../assets/Images/cross.png";
import job from "../../assets/Images/Group.png";
import key from "../../assets/Images/vecteezy_decision-making-icon-design_14631856 [Converted] 1.png";
import line from "../../assets/Images/Line 30.png";
import idea1 from "../../assets/Images/revenue_logo.jpg";
import { FaUserTie } from "react-icons/fa";
import { FaClipboardList } from "react-icons/fa6";
import autoTable from "jspdf-autotable";
import { useResearcher } from "../../context/ResearcherContext";
import {fetchUserData} from '../../api/index';
import Not_Verified from "../../assets/Images/NotVerified.png";
import Verified from "../../assets/Images/Verified.png";
import Expiring from "../../assets/Images/Expiring.png";

const requiredHeaders = [
  "First name",
  "Company Name",
  "Email",
  "Linkedin",
  "Designation",
  "Phone Number",
  "Website",
  "City",
  "State",
  "Country",
  "Industry",
  "Company Description",
  "Followers",
  "Technology Details",
  "Annual Revenue",
  "No of Employees",
  "Company Location",
  "Headquarter",
  "Sub Category",
  "Type of Customer",
  "Financial",
  "Investors",
  "Job Openings",
  "News and Social insights",
  "Competitors",
  "Partners",
  "Status"
];

const MyList = () => {
  const baseURL =
    process.env.NODE_ENV === "production"
      ? process.env.REACT_APP_API_URL_PROD
      : process.env.REACT_APP_API_URL_LOCAL;

  const location = useLocation();

  const selectedListNameDash = location.state?.listName;

  const { researcherId } = useResearcher();
  
  useEffect(() => {
    if (selectedListNameDash) {
    } else {
      console.log(" No list name was passed.");
    }
  }, [selectedListNameDash]);

  //open add details popup
  const [isAdd, setIsAdd] = useState(false);
  const [isAddList, setIsAddList] = useState(false);
  const [searchData, setSearchData] = useState("");

  const [isMyContacts, setIsMyContacts] = useState(false);
  const [isContacts, setIsContacts] = useState(false);

  //for post details
  const [details, setDetails] = useState({
    firstname: "",
    companyname: "",
    linkedin: "",
    email: "",
    designation: "",
    phonenumber: "",
    image: "",
    website: "",
    city: "",
    state: "",
    country: "",
    annualrevenue: "",
    noofemployees: "",
    companylocation: "",
    industry: "",
    headquarter: "",
    subcategory: "",
    typeofCustomer: "",
    companydescription: "",
    technologydetails: "",
    jobopenings: [{ jobname: "", jobdescription: "", jobsource: "" }],
    newsandsocialinsights: [
      { newsname: "", newsdescription: "", newssource: "" },
    ],
    financial: [
      { financialdescription: "", financialsourcelink: "", financialyear: "" },
    ],
    investors: [{ investors: "", investorsourcelink: "" }],
    competitors: "",
    partners: "",
  });

  const navigate = useNavigate();

  const [selectedFilters, setSelectedFilters] = useState({
    mycontacts: [],
    companyname: [],
    industry: [],
    designation: [],
    noofemployees: [],
    companylocation: [],
    annualrevenue: [],
    subcategory: [],
  });

  //store details in the state
  const [data, setData] = useState([]);
  const [research, setResearch] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  //count peoples
  const [selectedUserId, setSelectedUserId] = useState(null);

  //Profile popup
  const [isOpenListProfile, setIsOpenListProfile] = useState(false);

  //for search data
  //table pagination
  const [currentListPage, setCurrentListPage] = useState(1);
  //expand selected profile
  const [selectedItem, setSelectedItem] = useState(null);

  //show company details
  const [showCompany, setShowCompany] = useState(true);

  //show job openings
  const [showOpenings, setShowOpenings] = useState(false);
  const [showTechstack, setShowTechstack] = useState(false);
  const [showAccount, setShowAccount] = useState(false);
  const [showContact, setShowContact] = useState(false);

  //change background color on click
  const [companyColor, setCompanyColor] = useState("#FCB124");
  const [jobColor, setJobColor] = useState("");
  const [techColor, setTechColor] = useState("");
  const [contactColor, setContactColor] = useState("");
  const [accountColor, setAccountColor] = useState("");
  const [visibleNews, setVisibleNews] = useState(3);

  const [role, setRole] = useState("");

  const [uploadFile, setUploadFile] = useState(null);
  const [excelHeaders, setExcelHeaders] = useState([]);
  const [selectedFields, setSelectedFields] = useState({});
  const [showPopup, setShowPopup] = useState(false);

  const [editMode, setEditMode] = useState(false);
  const [editModeList, setEditModeList] = useState(false);
  const [currentusers, setCurrentUsers] = useState([]);
  const itemsListPerPage = 10;

  const [visibleColumns, setVisibleColumns] = useState({});

  //select checkbox for download file
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAll, setSelectAll] = useState();

  const [showMissingFieldsPopup, setShowMissingFieldsPopup] = useState(false);
  const [missingFields, setMissingFields] = useState([]);

  const [activeContainer, setActiveContainer] = useState("singleRequests");

  //credits count
  const [credits, setCredits] = useState(0);
  const [spentCredits, setSpentCredits] = useState(0);
  const [remainingCredits, setRemainingCredits] = useState(0);

  const [showForm, setShowForm] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [formData, setFormData] = useState({
    firstname: "",
    companyname: "",
    linkedin: "",
    email: "",
    designation: "",
    phonenumber: "",
    image: "",
    website: "",
    city: "",
    state: "",
    country: "",
    annualrevenue: "",
    noofemployees: "",
    companylocation: "",
    industry: "",
    headquarter: "",
    subcategory: "",
    typeofCustomer: "",
    companydescription: "",
    followers: "",
    technologydetails: "",
    jobopenings: [{ jobname: "", jobdescription: "", jobsource: "" }],
    newsandsocialinsights: [
      { newsname: "", newsdescription: "", newssource: "" },
    ],
    financial: [
      { financialdescription: "", financialsourcelink: "", financialyear: "" },
    ],
    investors: [{ investors: "", investorsourcelink: "" }],
    competitors: "",
    partners: "",
    status: "Pending",
  });

  const [isResearch, setIsResearch] = useState(false);
  const [requests, setRequests] = useState([]);

  const [extraFields, setExtraFields] = useState([{ label: "", value: "" }]);
  const [newFieldLabel, setNewFieldLabel] = useState("");
  const [showLabelInput, setShowLabelInput] = useState(false);
  const [expandedNewsIndex, setExpandedNewsIndex] = useState(null);
  const [expandedJobIndex, setExpandedJobIndex] = useState(null);

  //For table designation
  const [listName, setListName] = useState("");
  const [showlist, setShowlist] = useState(false);
  const [selectedList, setSelectedList] = useState([]);
  const [userlists, setuserlists] = useState(false);
  const [list, setList] = useState([]);
  const [selectedListName, setSelectedListName] = useState("");
  const [hover, setHover] = useState(false);
  const [scoopHover, setScoopHover] = useState(false);
  const [viewedProfiles, setViewedProfiles] = useState([]);

  const listNameFromDashboard = location.state?.listName || "";
  const [filteredList, setFilteredList] = useState(null);
  const [requestedData, setRequestedData] = useState([]);

  useEffect(() => {
    const userRole = localStorage.getItem("role");
    setRole(userRole);
  }, []);

  useEffect(() => {
    if (listName) {
      setSelectedListName(listName);
    }
  }, [listName]);

  const [adminId, setAdminId] = useState(null);

  useEffect(() => {
    const fetchAdminId = async () => {
      try {
        const response = await axios.get(`${baseURL}/api/getadminid`);
        setAdminId(response.data.adminId);
      } catch (err) {
        console.error(
          "Failed to fetch admin ID:",
          err.response?.data?.message || err.message
        );
      }
    };

    fetchAdminId();
  }, []);

    const fetchUsers = async (chunkIndex) => {
      const token = localStorage.getItem("token");
  
      const skip = 0;
      const limit = 50;
    if (!token) {
      console.error("No token found.");
      return;
    }
  
    try {
      const data = await fetchUserData(skip, limit);
      
      setCredits(data.subscriptions[0].credits);
      setRemainingCredits(data.subscriptions[0].remainingcredits);
      setSpentCredits(data.subscriptions[0].spentcredits)
      setRequestedData(data.requestedData || []);
    } catch (error) {
      console.error("Error fetching chunk:", error);
    }
    };
  
    useEffect(() => {
      fetchUsers();
    }, []);
  
   useEffect(() => {
  const openId = location.state?.openProfileId;
  const selectedListName = location.state?.selectedListName;

  if (openId && selectedListName && list.length > 0) {
    const selectedList = list.find((l) => l.listName === selectedListName);
    if (selectedList) {
      const itemToExpand = selectedList.users.find((u) => u._id === openId);
      if (itemToExpand) {
        setSelectedItem(itemToExpand);
        setIsOpenListProfile(true);
        
      }
    }
  }
}, [location.state, list]);
 
  useEffect(() => {}, [list, selectedList]);

  useEffect(() => {}, [selectedRequest, showForm]);
  

  const fetchLists = async () => {
    setIsLoading(true);
    const token = localStorage.getItem("token");
    if (!token) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "You need to login first",
      });
      return;
    }

    try {
      const response = await fetch(`${baseURL}/api/get-lists`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      setViewedProfiles(data.viewedProfiles);
      if (response.ok) {
        if (data.lists?.length) {
          const validatedLists = data.lists.map((list) => ({
            _id: list._id || new Date().getTime(),
            ...list,
          }));

          const sortedData = validatedLists.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );

          setList(sortedData);

          // Set the selected list from Dashboard if available
          if (listNameFromDashboard) {
            const matched = sortedData.find(
              (l) => l.listName === listNameFromDashboard
            );
            if (matched) {
              setSelectedListName(matched.listName);
              setFilteredList(matched);
            }
          } else {
            setSelectedListName(sortedData[0].listName);
            setFilteredList(sortedData[0]);
          }
        } else {
          console.warn("No lists found");
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: data.message || "Failed to fetch lists.",
        });
      }
      setIsLoading(false);
    } catch (err) {
      console.error("Error fetching lists:", err);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Error occurred while fetching lists.",
      });
    }
  };

  useEffect(() => {
    fetchLists();
  }, [selectedListName]);


  useEffect(() => {
    setuserlists(true);
  }, []);


  useEffect(() => {
    if (!list) return;

    let filtered = [...list];

    Object.entries(selectedFilters).forEach(([field, selectedValues]) => {
      if (selectedValues.length > 0) {
        filtered = filtered.filter((item) =>
          selectedValues.includes(item[field])
        );
      }
    });
  }, [list, selectedFilters]);

  useEffect(() => {
    if (
      !filteredList ||
      !Array.isArray(filteredList.users) ||
      !filteredList.users.length
    )
      return;

    const columnsVisibility = Object.keys(filteredList.users[0]).reduce(
      (acc, key) => {
        acc[key] = filteredList.users.some((item) => item[key]);
        return acc;
      },
      {}
    );

    setVisibleColumns((prevColumns) =>
      JSON.stringify(prevColumns) !== JSON.stringify(columnsVisibility)
        ? columnsVisibility
        : prevColumns
    );
  }, [filteredList]);

    const handleDisplayMyContacts = () => {
    setSearchData("");
    setIsMyContacts(true);
    setIsContacts(false);
    setuserlists(false);
    setSelectedRows([]);
    setSelectAll();
  };

  const handleDisplayContacts = () => {
    setSearchData("");
    setIsMyContacts(false);
    setIsContacts(true);
    setuserlists(false);
    setSelectedRows([]);
    setSelectAll();
  };

  const handleListSelection = (listName) => {
    setSelectedListName(listName);

    const matched = list.find((list) => list.listName === listName);
    if (matched) {
      setFilteredList(matched);
    }
    if (location.pathname !== "/my-list") {
      navigate("/my-list");
    }
  };


  const applyFieldFilters = (users) => {
    return users.filter((user) => {
      return Object.entries(selectedFilters).every(
        ([field, selectedOptions]) => {
          if (selectedOptions.length === 0) return true;

          const userFieldValue = user[field];

          if (Array.isArray(userFieldValue)) {
            return userFieldValue.some((val) => selectedOptions.includes(val));
          }

          return selectedOptions.includes(userFieldValue);
        }
      );
    });
  };

  const rawUsers = Array.isArray(filteredList?.users) ? filteredList.users : [];

  const filteredUsers = applyFieldFilters(rawUsers);

  const totalListPages = Math.ceil(filteredUsers.length / itemsListPerPage);

  const indexOfLastItem = currentListPage * itemsListPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsListPerPage;
  const currentUsers = filteredUsers.slice(indexOfFirstItem, indexOfLastItem);

  const handlePageChange = (pageNumber) => {
    setCurrentListPage(pageNumber);
  };

  const handleSetActive = (containerName) => {
    setActiveContainer(containerName);
  };

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };

  const handleCloseOverlay = () => {
    if (isAdd) {
      setIsAdd(false);
    } else if (editMode) {
      setEditMode(false);
    }
    setSelectedRows([]);
    setDetails({
      firstname: "",
      companyname: "",
      linkedin: "",
      email: "",
      designation: "",
      phonenumber: "",
      website: "",
      city: "",
      state: "",
      country: "",
      annualrevenue: "",
      noofemployees: "",
      companylocation: "",
      industry: "",
      headquarter: "",
      subcategory: "",
      typeofCustomer: "",
      companydescription: "",
      technologydetails: "",
      jobopenings: [{ jobname: "", jobdescription: "", jobsource: "" }],
      newsandsocialinsights: [
        { newsname: "", newsdescription: "", newssource: "" },
      ],
      financial: [
        {
          financialdescription: "",
          financialsourcelink: "",
          financialyear: "",
        },
      ],
      investors: [{ investors: "", investorsourcelink: "" }],
      competitors: "",
      partners: "",
    });
  };

  const handleDownloadEntireListExcel = async () => {

    const selectedList = list.find(
      (listItem) => listItem.listName === selectedListName
    );

    if (!selectedList) {
      Swal.fire({
        icon: "error",
        title: "No List Found",
        text: "The selected list does not exist.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
      return;
    }

    const selectedUserIds = selectedList.users.map((user) => user._id);

    // If role is user, verify all are viewed
    if (role === "user") {
      const missingIds = selectedUserIds.filter(
        (id) => !viewedProfiles.includes(id)
      );

      if (missingIds.length > 0) {
        Swal.fire({
          icon: "warning",
          title: "Incomplete Access",
          text: "You must unlock all scoops before downloading the full data.",
          confirmButtonColor: "#FCB124",
          confirmButtonText: "Ok",
        });
        return;
      }
    }

    try {
      const token = localStorage.getItem("token");

      const response = await fetch(
        `${baseURL}/api/download-list/${encodeURIComponent(selectedListName)}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to download file");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = `${selectedListName}_FullListData.xlsx`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      Swal.fire({
        icon: "success",
        title: "Download Complete!",
        text: "Entire list data downloaded successfully!",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Download Failed",
        text: "Failed to download the Excel file. Please try again later.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
    }
  };

  useEffect(() => {
    if (research.extraFields && research.extraFields.length > 0) {
      setExtraFields(research.extraFields);
    } else {
      setExtraFields([]);
    }
  }, [research]);

  const selectedUsersCount = list
    .filter((listItem) => listItem.listName === selectedListName)
    .flatMap((listItem) => listItem.users || []).length;

  const handleFinanceChange = (e, index, field) => {
    const newFinancialDetails = [...details.financial];
    newFinancialDetails[index][field] = e.target.value;
    setDetails({ ...details, financial: newFinancialDetails });
  };

  const addFinancial = () => {
    setDetails({
      ...details,
      financial: [
        ...details.financial,
        { financialdescription: "", financesourcelink: "", financialyear: "" },
      ],
    });
  };

  const removeFinancial = (index) => {
    const newFinancialDetails = details.financial.filter((_, i) => i !== index);
    setDetails({ ...details, financial: newFinancialDetails });
  };

  const handleInvestorChange = (e, index, field) => {
    const newInvestorDetails = [...details.investors];
    newInvestorDetails[index][field] = e.target.value;
    setDetails({ ...details, investors: newInvestorDetails });
  };

  const addInvestor = () => {
    setDetails({
      ...details,
      investors: [
        ...details.investors,
        { investors: "", investorsourcelink: "" },
      ],
    });
  };

  const removeInvestor = (index) => {
    const newInvestorDetails = details.investors.filter((_, i) => i !== index);
    setDetails({ ...details, investors: newInvestorDetails });
  };

  const handleJobChange = (e, index, field) => {
    const newJobOpenings = [...details.jobopenings];
    newJobOpenings[index][field] = e.target.value;
    setDetails({ ...details, jobopenings: newJobOpenings });
  };

  const addJobOpening = () => {
    setDetails({
      ...details,
      jobopenings: [
        ...details.jobopenings,
        { jobname: "", jobdescription: "", jobsource: "" },
      ],
    });
  };

  const removeJobOpening = (index) => {
    const newJobOpenings = details.jobopenings.filter((_, i) => i !== index);
    setDetails({ ...details, jobopenings: newJobOpenings });
  };

  const handleNewsChange = (e, index, field) => {
    const newNews = [...details.newsandsocialinsights];
    newNews[index][field] = e.target.value;
    setDetails({ ...details, newsandsocialinsights: newNews });
  };

  const addNews = () => {
    setDetails({
      ...details,
      newsandsocialinsights: [
        ...details.newsandsocialinsights,
        { newsname: "", newsdescription: "", newssource: "" },
      ],
    });
  };

  const removeNews = (index) => {
    const newNews = details.newsandsocialinsights.filter((_, i) => i !== index);
    setDetails({ ...details, newsandsocialinsights: newNews });
  };

  const handleFinanceFormChange = (e, index, field) => {
    const newFinancialDetails = [...formData.financial];
    newFinancialDetails[index][field] = e.target.value;
    setFormData({ ...formData, financial: newFinancialDetails });
  };

  const addFinancialForm = () => {
    setFormData({
      ...formData,
      financial: [
        ...formData.financial,
        { financialdescription: "", financesourcelink: "", financialyear: "" },
      ],
    });
  };

  const removeFinancialForm = (index) => {
    const newFinancialDetails = formData.financial.filter(
      (_, i) => i !== index
    );
    setFormData({ ...formData, financial: newFinancialDetails });
  };

  const handleInvestorFormChange = (e, index, field) => {
    const newInvestorDetails = [...formData.investors];
    newInvestorDetails[index][field] = e.target.value;
    setFormData({ ...formData, investors: newInvestorDetails });
  };

  const addInvestorForm = () => {
    setFormData({
      ...formData,
      investors: [
        ...formData.investors,
        { investors: "", investorsourcelink: "" },
      ],
    });
  };

  const removeInvestorForm = (index) => {
    const newInvestorDetails = formData.investors.filter((_, i) => i !== index);
    setFormData({ ...formData, investors: newInvestorDetails });
  };

  const handleJobFormChange = (e, index, field) => {
    const newJobOpenings = [...formData.jobopenings];
    newJobOpenings[index][field] = e.target.value;
    setFormData({ ...formData, jobopenings: newJobOpenings });
  };

  const addJobOpeningForm = () => {
    setFormData({
      ...formData,
      jobopenings: [
        ...formData.jobopenings,
        { jobname: "", jobdescription: "", jobsource: "" },
      ],
    });
  };

  const removeJobOpeningForm = (index) => {
    const newJobOpenings = formData.jobopenings.filter((_, i) => i !== index);
    setFormData({ ...formData, jobopenings: newJobOpenings });
  };

  const handleNewsFormChange = (e, index, field) => {
    const newNews = [...formData.newsandsocialinsights];
    newNews[index][field] = e.target.value;
    setFormData({ ...formData, newsandsocialinsights: newNews });
  };

  const addNewsForm = () => {
    setFormData({
      ...formData,
      newsandsocialinsights: [
        ...formData.newsandsocialinsights,
        { newsname: "", newsdescription: "", newssource: "" },
      ],
    });
  };

  const removeNewsForm = (index) => {
    const newNews = formData.newsandsocialinsights.filter(
      (_, i) => i !== index
    );
    setFormData({ ...formData, newsandsocialinsights: newNews });
  };

  const handleShowMoreNews = () => {
    setVisibleNews((prev) => prev + 3);
  };

  const saveCreditsToDB = async (credits, spentcredits, remainingcredits) => {
    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("token");
    try {
      const response = await fetch(`${baseURL}/api/update-credits/${userId}`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ credits, spentcredits, remainingcredits }),
      });

      const data = await response.json();
    } catch (error) {
      console.error("Error saving credits:", error);
    }
  };

  const handleOpenListProfile = async (listName, userId) => {
    if (remainingCredits === 0) {
      Swal.fire({
        icon: "warning",
        title: "No Remaining Credits",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
      return;
    }
    const selectedList = list.find((list) => list.listName === listName);
    if (!selectedList) {
      console.error("List not found");
      return;
    }

    const itemToExpand = selectedList.users.find((user) => user._id === userId);
    if (!itemToExpand) {
      console.error("User not found in list");
      return;
    }

    setSelectedItem(itemToExpand);
    setIsOpenListProfile(true);

    if (!viewedProfiles.includes(userId)) {
      const updatedViewed = [...viewedProfiles, userId];
      const updatedSpent = spentCredits + 1;
      const updatedRemaining = remainingCredits - 1;

      setSpentCredits(updatedSpent);
      setRemainingCredits(updatedRemaining);
      setViewedProfiles(updatedViewed);

      const token = localStorage.getItem("token");
      try {
        await axios.put(
          `${baseURL}/api/viewed-profiles`,
          { profileId: userId },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        saveCreditsToDB(credits, updatedSpent, updatedRemaining);
      } catch (error) {
        console.error("Failed to mark profile as viewed:", error);
        alert(
          "Something went wrong while updating profile view. Please try again."
        );
      }
    }
  };

  const isEnabled = viewedProfiles.includes(selectedUserId);

  const goToListPage = (page) => {
    if (page >= 1 && page <= totalListPages) {
      setCurrentListPage(page);
    }
  };

  const handleEditList = (listName, userId) => {

    const itemToEdit = list.find((item) => item.listName === listName);
    if (!itemToEdit) return;

    const getEditItem = itemToEdit.users.find((item) => item._id === userId);
    if (!getEditItem) return;

    setSelectedListName(listName);
    setList(getEditItem);
    setEditModeList(true);
    setIsAddList(false);
  };

  const handleDeleteList = async () => {
    const token = localStorage.getItem("token");

    if (selectedRows.length === 0) {
      await Swal.fire({
        icon: "warning",
        title: "No Selection",
        text: "Please select at least one entry to delete.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
      return;
    }

    try {
      const response = await fetch(
        `${baseURL}/api/user-list/${selectedListName}/${details._id}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            userIds: selectedRows,
          }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        // Update frontend state
        const updatedUsers = currentUsers.filter(
          (user) => !selectedRows.includes(String(user._id))
        );
        setCurrentUsers(updatedUsers);
        setSelectedRows([]);
        setSelectAll(false);
        await Swal.fire({
          icon: "success",
          title: "Contact(s) deleted successfully",
          confirmButtonColor: "#FCB124",
        });
        fetchLists();
      } else {
        console.error("Delete error:", data.message);
        await Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to delete contact(s).",
          confirmButtonColor: "#FCB124",
        });
      }
    } catch (error) {
      console.error("Error deleting users:", error);
      await Swal.fire({
        icon: "error",
        title: "An error occurred while deleting contact(s).",
        confirmButtonColor: "#FCB124",
      });
    }
  };

  const handleShowCompany = () => {
    setCompanyColor("#FCB124");
    setContactColor("#fff");
    setJobColor("#fff");
    setTechColor("#fff");
    setAccountColor("#fff");
    setShowCompany(true);
    setShowTechstack(false);
    setShowAccount(false);
    setShowContact(false);
    setShowOpenings(false);
  };

  const handleShowTechStack = () => {
    setCompanyColor("#fff");
    setTechColor("#FCB124");
    setContactColor("#fff");
    setJobColor("#fff");
    setAccountColor("#fff");
    setShowTechstack(true);
    setShowAccount(false);
    setShowCompany(false);
    setShowContact(false);
    setShowOpenings(false);
  };

  const handleShowContact = () => {
    setContactColor("#FCB124");
    setCompanyColor("#fff");
    setTechColor("#fff");
    setJobColor("#fff");
    setAccountColor("#fff");
    setShowCompany(false);
    setShowAccount(false);
    setShowTechstack(false);
    setShowContact(true);
    setShowOpenings(false);
  };

  const handleShowAccount = () => {
    setContactColor("#fff");
    setCompanyColor("#fff");
    setTechColor("#fff");
    setJobColor("#fff");
    setAccountColor("#FCB124");
    setShowAccount(true);
    setShowCompany(false);
    setShowTechstack(false);
    setShowContact(false);
    setShowOpenings(false);
  };

  const handleCloseProfile = () => {
  setIsOpenListProfile(false);
  navigate(location.pathname, {
    replace: true, 
    state: { ...location.state, openProfileId: null },
  });
};

  const getStatusprofile = (status) => {
    return status === "Active"
      ? "status-active-profile"
      : "status-inactive-profile";
  };

  const handleShowOpenings = (e) => {
    e.stopPropagation();
    setJobColor("#FCB124");
    setCompanyColor("#fff");
    setContactColor("#fff");
    setAccountColor("#fff");
    setTechColor("#fff");
    setShowAccount(false);
    setShowCompany(false);
    setShowContact(false);
    setShowTechstack(false);
    setShowOpenings(true);
  };

const downloadListPDF = (profilePopupData) => {
  if (!profilePopupData || !profilePopupData._id) {
    alert("No profile selected for download!");
    return;
  }

  const doc = new jsPDF();
  let y = 20;

  // 1️⃣ Title - Stylish
  doc.setFont("helvetica", "bold");
  doc.setFontSize(20);
  doc.setTextColor(44, 62, 80); 
  doc.text("User Profile Report", 14, y);
  doc.setDrawColor(44, 62, 80);
  doc.line(14, y + 2, 200, y + 2);
  y += 10;

  // 2️⃣ Build profile data
  const infoData = [
    ["Full Name", `${profilePopupData.firstname || ""} ${profilePopupData.lastname || ""}`],
    ["Email", profilePopupData.email || "N/A"],
    ["Phone", profilePopupData.phonenumber || "N/A"],
    ["Headquarters", profilePopupData.headquarters || "N/A"],
    ["Subcategory", profilePopupData.subcategory || "N/A"],
    ["Company Name", profilePopupData.companyname || "N/A"],
    ["Company Description", profilePopupData.companydescription || "N/A"],
    ["Website", profilePopupData.website || "N/A"],
    ["Designation", profilePopupData.designation || "N/A"],
    ["Industry", profilePopupData.industry || "N/A"],
    ["Technology Details", profilePopupData.technologydetails || "N/A"],
  ];

  // 3️⃣ Draw the table
  autoTable(doc, {
    startY: y,
    head: [["Field", "Value"]],
    body: infoData,
    styles: {
      fontSize: 11,
      cellPadding: 4,
    },
    headStyles: {
      fillColor: [52, 152, 219], 
      textColor: [255, 255, 255],
    },
    alternateRowStyles: {
      fillColor: [245, 245, 245],
    },
    margin: { top: 10 },
  });

  // 4️⃣ Save the file
  const fileName = `${profilePopupData.firstname || "profile"}.pdf`;
  doc.save(fileName);
};

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const allowedTypes = [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.ms-excel",
    ];

    if (!allowedTypes.includes(file.type)) {
      alert("Please upload a valid Excel file (.xlsx or .xls)!");
      return;
    }

    setUploadFile(file);
    setSelectedFields({});
  };

  // Handle file upload
  const handleUpload = async () => {
    if (!uploadFile) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please select a file first!",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
      return;
    }

    const reader = new FileReader();
    reader.onload = async (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
      let headers = jsonData[0] || [];

      // Ensure headers are strings, trimmed, and converted to lowercase
      headers = headers.map((header) =>
        header ? header.toString().trim() : ""
      );

      if (headers.length === 0) {
        alert("The uploaded file is empty or does not contain headers.");
        return;
      }

      setExcelHeaders(headers);
      setShowPopup(true);
    };

    reader.readAsArrayBuffer(uploadFile);
  };

  // Handle field mapping
  const handleMappingChange = (uploadedHeader, selectedValue) => {
    setSelectedFields((prevMapping) => {
      const updatedMapping = { ...prevMapping };

      if (selectedValue) {
        updatedMapping[uploadedHeader] = selectedValue;
      } else {
        delete updatedMapping[uploadedHeader];
      }

      return updatedMapping;
    });
  };

  // Function to Cancel Upload
  const handleCancelUpload = () => {
    setShowMissingFieldsPopup(false);
  };

  const handleProceedUpload = async () => {
    setShowMissingFieldsPopup(false);
    const token = localStorage.getItem("token");

    if (!token) {
      Swal.fire({
        icon: "error",
        title: "Authentication Error",
        text: "You need to log in again.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
      return;
    }

    if (!uploadFile) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please select a file first!",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
      return;
    }

    const reader = new FileReader();
    reader.readAsBinaryString(uploadFile);

    reader.onloadend = async (e) => {
      try {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: "binary" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];

        let jsonData = XLSX.utils.sheet_to_json(worksheet);

        if (jsonData.length === 0) {
          Swal.fire({
            icon: "error",
            title: "Empty File",
            text: "The uploaded file is empty!",
          });
          return;
        }

        const formattedData = jsonData.map((row) => ({
          firstname: row["First Name"]?.trim() || "",
          companyname: row["Company Name"]?.trim() || "",
          linkedin: row["LinkedIn"]?.trim() || "",
          email: row["Email"]?.trim() || "",
          designation: row["Designation"]?.trim() || "",
          phonenumber: row["Phone Number"]?.trim() || "",
          website: row["Website"]?.trim() || "",
          city: row["City"]?.trim() || "",
          state: row["State"]?.trim() || "",
          country: row["Country"]?.trim() || "",
          annualrevenue: row["Annual Revenue"]?.trim() || "",
          noofemployees: row["No of Employees"] || "",
          companylocation: row["Company Location"]?.trim() || "",
          industry: row["Industry"]?.trim() || "",
          headquarter: row["Headquarter"]?.trim() || "",
          subcategory: row["Subcategory"]?.trim() || "",
          typeofcustomer: row["Type of Customer"]?.trim() || "",
          companydescription: row["Company Description"]?.trim() || "",
          followers: row["Followers"] || "",
          technologydetails: row[" Technology Details"]?.trim() || "",
          competitors: row["Competitors"]?.trim() || "",
          partners: row["Partners"]?.trim() || "",
          jobopenings: row["Job Openings"]
            ? parseExcelDetails(row["Job Openings"], "jobopenings")
            : [],
          newsandsocialinsights: row["News and Social Insights"]
            ? parseExcelDetails(
                row["News and Social Insights"],
                "newsandsocialinsights"
              )
            : [],
          financial: row["Financial"]
            ? parseExcelDetails(row["Financial"], "financial")
            : [],
          investors: row["Investors"]
            ? parseExcelDetails(row["Investors"], "investors")
            : [],
        }));

        const formData = new FormData();
        formData.append("file", uploadFile);
        formData.append("data", JSON.stringify(formattedData));
        formData.append("selectedFields", JSON.stringify(selectedFields));
        formData.append("confirmUpload", true);
        formData.append("adminId", adminId);
        formData.append("listName", selectedListName);

        const uploadUrl = `${baseURL}/api/upload-list-excel`;

        const response = await fetch(uploadUrl, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formData,
        });

        const responseData = await response.json();

        if (response.ok) {
          Swal.fire({
            icon: "success",
            title: "Upload Successful",
            text: responseData.message || "File uploaded successfully.",
          });

          if (
            responseData.insertedData &&
            Array.isArray(responseData.insertedData)
          ) {
            setSelectedList(responseData.insertedData);
            fetchLists();
          }
        } else {
          Swal.fire({
            icon: "warning",
            title: "Upload Failed",
            text: responseData.error || "An error occurred during upload.",
          });
        }
        setUploadFile(null);
      } catch (err) {
        console.error("Upload error:", err);
        Swal.fire({
          icon: "error",
          title: "Upload Error",
          text: "An unexpected error occurred.",
        });
      }
    };
  };

  const parseExcelDetails = (dataString, type) => {
    if (!dataString || typeof dataString !== "string") return [];

    return dataString
      .replace(/^\[|\]$/g, "")
      .split(/\],\s*\[/)
      .map((entry) => {
        const parts = entry.split(" | ").map((part) => {
          const trimmedPart = part.trim();
          return trimmedPart.toLowerCase() === "null" || trimmedPart === ""
            ? ""
            : trimmedPart;
        });

        let parsedEntry = {};

        switch (type) {
          case "jobopenings":
            parsedEntry = {
              jobname: parts[0] || "",
              jobdescription: parts[1] || "",
              jobsource: parts[2] || "",
            };
            break;
          case "newsandsocialinsights":
            parsedEntry = {
              newsname: parts[0] || "",
              newsdescription: parts[1] || "",
              newssource: parts[2] || "",
            };
            break;
          case "financial":
            parsedEntry = {
              financialdescription: parts[0] || "",
              financialsourcelink: parts[1] || "",
              financialyear: parts[2] || "",
            };
            break;
          case "investors":
            parsedEntry = {
              investors: parts[0] || "",
              investorsourcelink: parts[1] || "",
            };
            break;
          default:
            console.warn(`Unknown type: ${type}`);
            parsedEntry = { error: `Invalid type: ${type}` };
            break;
        }

        return parsedEntry;
      });
  };

  const handleCheckMissingFields = async () => {
    if (!uploadFile) {
      console.error("🚨 No file selected");
      alert("Please select a file before uploading.");
      return;
    }

    const token = localStorage.getItem("token");
    if (!token) {
      Swal.fire({
        icon: "error",
        title: "Authentication Error",
        text: "You need to log in again.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
      return;
    }

    const formData = new FormData();
    formData.append("file", uploadFile);
    formData.append("selectedFields", JSON.stringify(selectedFields));

    const uploadUrl =
      role === "admin"
        ? `${baseURL}/api/upload-admin-excel`
        : `${baseURL}/api/upload-excel`;

    try {
      const previewResponse = await fetch(uploadUrl, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      const previewData = await previewResponse.json();

      if (previewData.missingFields && previewData.missingFields.length > 0) {
        setMissingFields(previewData.missingFields);
        setShowMissingFieldsPopup(true);
        setShowPopup(false);
      } else {
        handleUpload(true);
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error Checking Missing Fields",
        text: "An error occurred while checking for missing fields. Please try again.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
    }
  };

 const handleOpenListEmailCampaign = (listName, id,) => {
  navigate(`/campaign/${listName}/${id}`, { 
    state: { 
      fromList: true,   
      openProfileId: id,
      selectedListName: listName,
      
    } 
  });
};
const handleDetailList = (listName, id) => {
  navigate(`/companypage/${listName}/${id}`, { state: { from: "my-list", listName, id } });
};


  const handleCheckboxChange = (id) => {
    setSelectedRows((prevSelected) => {
      const isAlreadySelected = prevSelected.includes(id);

      const newSelected = isAlreadySelected
        ? prevSelected.filter((i) => i !== id)
        : [...prevSelected, id];

      setSelectedUserId(
        newSelected.length > 0 ? newSelected[newSelected.length - 1] : null
      );

      return newSelected;
    });
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedRows([]);
    } else {
      setSelectedRows(currentUsers.map((user) => user._id));
    }
    setSelectAll(!selectAll);
  };

  const handleSavelist = async (e) => {
    e.preventDefault();

    const token = localStorage.getItem("token");

    if (!token) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "You need to login first",
      });
      return navigate("/login");
    }

    try {
      const apiUrl = `${baseURL}/api/user-list`;

      const payload = {
        listName: selectedListName,
        ...details,
      };

      let response;

      if (editModeList) {
        response = await axios.put(
          `${apiUrl}/${selectedListName}/${details._id}`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
      } else {
        response = await axios.post(apiUrl, payload, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
      }

      Swal.fire({
        icon: "success",
        title: editModeList ? "Contact Updated" : "Contact Added",
        text: editModeList
          ? "Contact Updated Successfully"
          : "Contact Added Successfully",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });

      fetchLists();
      setIsAddList(false);
      setEditModeList(false);
      setSelectedRows([]);
      setDetails({
        firstname: "",
        companyname: "",
        linkedin: "",
        email: "",
        designation: "",
        phonenumber: "",
        website: "",
        city: "",
        state: "",
        country: "",
        annualrevenue: "",
        noofemployees: "",
        companylocation: "",
        industry: "",
        headquarter: "",
        subcategory: "",
        typeofCustomer: "",
        companydescription: "",
        technologydetails: "",
        jobopenings: [{ jobname: "", jobdescription: "", jobsource: "" }],
        newsandsocialinsights: [
          { newsname: "", newsdescription: "", newssource: "" },
        ],
        financial: [
          {
            financialdescription: "",
            financialsourcelink: "",
            financialyear: "",
          },
        ],
        investors: [{ investors: "", investorsourcelink: "" }],
        competitors: "",
        partners: "",
      });
    } catch (error) {
      console.error("Error saving list:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.message || "Something went wrong",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
    }
  };

  const handleDownloadListExcel = () => {
    if (selectedRows.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "Selection Required!",
        text: "Please select at least one row to download.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "Ok",
      });
      return;
    }

    const unviewedIds = selectedRows.filter(
      (id) => !viewedProfiles.includes(id)
    );

    if (unviewedIds.length > 0) {
      Swal.fire({
        icon: "warning",
        title: "Access Denied",
        text: "You can only download scoops you’ve already unlocked.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "Ok",
      });
      setSelectedRows([]);
      setSelectAll();
      return;
    }

    // Define expected headers
    const expectedHeaders = [
      "firstname",
      "companyname",
      "linkedin",
      "email",
      "designation",
      "phonenumber",
      "website",
      "city",
      "state",
      "country",
      "annualrevenue",
      "noofemployees",
      "companylocation",
      "industry",
      "headquarter",
      "subcategory",
      "typeofCustomer",
      "companydescription",
      "followers",
      "technologydetails",
      "jobopenings",
      "newsandsocialinsights",
      "financial",
      "investors",
      "competitors",
      "partner",
    ];

    // Filter selected data from paginatedData
    const selectedData = currentUsers.filter((row) =>
      selectedRows.includes(row._id)
    );
    if (selectedData.length === 0) {
      Swal.fire({
        icon: "error",
        title: "No Data",
        text: "No valid data found for download.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
      return;
    }

    // Format array fields like jobopenings, etc.
    const formatArrayField = (dataArray, fieldNames) => {
      if (!Array.isArray(dataArray) || dataArray.length === 0) return "";
      return dataArray
        .map(
          (item) =>
            `[${fieldNames.map((field) => item[field] || "").join(" | ")}]`
        )
        .join(", ");
    };

    // Format data according to headers
    const formattedData = selectedData.map((row) =>
      expectedHeaders.reduce((formattedRow, header) => {
        const arrayFieldMappings = {
          jobopenings: ["jobname", "jobdescription", "jobsource"],
          newsandsocialinsights: ["newsname", "newsdescription", "newssource"],
          financial: [
            "financialdescription",
            "financialsourcelink",
            "financialyear",
          ],
          investors: ["investors", "investorsourcelink"],
        };

        if (arrayFieldMappings[header]) {
          formattedRow[header] = formatArrayField(
            row[header],
            arrayFieldMappings[header]
          );
        } else {
          formattedRow[header] = row[header] || "";
        }

        return formattedRow;
      }, {})
    );

    try {
      const worksheet = XLSX.utils.json_to_sheet(formattedData, {
        header: expectedHeaders,
      });
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Selected Data");
      XLSX.writeFile(workbook, "SelectedData.xlsx");

      Swal.fire({
        icon: "success",
        title: "Download Successful",
        text: "File downloaded successfully!",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });

      setSelectedRows([]);
      setSelectAll();
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Download Failed",
        text: "Failed to download the Excel file. Please try again later.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
      setSelectedRows([]);
      setSelectAll();
    }
  };

  const getImageData = (status) => {
      switch (status) {
        case "Not Verified":
          return { src: Not_Verified, alt: "Not Verified", tooltip: "Not Verified" };
        case "Verified":
          return { src: Verified, alt: "Verified", tooltip: "Verified" };
        case "Expiring":
          return { src: Expiring, alt: "Expiring", tooltip: "Expiring Soon" };
        default:
          return { src: Not_Verified, alt: "Not Verified", tooltip: "Not Verified" };
      }
    };

  const handleDisplayUserLists = () => {
    setuserlists(true);
    setSearchData("");
    setSelectedRows([]);
    setSelectAll();
  };

const handleRequestData = async (item) => { 
  const token = localStorage.getItem("token");
  const userId = localStorage.getItem("userId");
  const userName = localStorage.getItem("name");
  const userEmail = localStorage.getItem("email");

  if (!token) {
    Swal.fire({
      icon: "warning",
      title: "Access Denied",
      text: "You must log in first!",
      confirmButtonColor: "#FCB124",
      confirmButtonText: "OK",
    });
    return;
  }

  const id = item._id;
  const updatedViewed = [...requestedData, id];
  setRequestedData(updatedViewed);

  const missingFields = {};
  const availableFields = {};
  const checkFields = [
    "technologydetails",
    "jobopenings",
    "newsandsocialinsights",
    "financial",
    "investors",
  ];

  checkFields.forEach((field) => {
    const value = item[field];
    const isEmpty =
      value === undefined ||
      value === null ||
      (typeof value === "string" && value.trim() === "") ||
      (Array.isArray(value) && value.length === 0);

    if (isEmpty) {
      missingFields[field] = field === "technologydetails" ? "" : [];
    } else {
      availableFields[field] = value;
    }
  });

  if (Object.keys(missingFields).length === 0) {
    Swal.fire({
      icon: "success",
      title: "All mandatory fields are available.",
      text: "No request needed.",
      confirmButtonColor: "#FCB124",
      confirmButtonText: "Okay",
    });
    return;
  }

  const requestData = {
    researcherId,
    adminId,
    userId,
    userName,
    userEmail,
    matchId: item._id,
    listname: selectedListName,
    firstname: item.firstname || "",
    companyname: item.companyname || "",
    linkedin: item.linkedin || "",
    email: item.email || "",
    designation: item.designation || "",
    phonenumber: item.phonenumber || "",
    website: item.website || "",
    city: item.city || "",
    state: item.state || "",
    country: item.country || "",
    annualrevenue: item.annualrevenue || "",
    noofemployees: item.noofemployees || "",
    companylocation: item.companylocation || "",
    industry: item.industry || "",
    headquarter: item.headquarter || "",
    subcategory: item.subcategory || "",
    typeofCustomer: item.typeofCustomer || "",
    companydescription: item.companydescription || "",
    technologydetails: item.technologydetails || "",
    jobopenings: item.jobopenings || [],
    newsandsocialinsights: item.newsandsocialinsights || [],
    financial: item.financial || [],
    investors: item.investors || [],
    competitors: item.competitors || "",
    partners: item.partners || "",
    status: item.status || "Pending",
    createdAt: item.createdAt || new Date().toISOString(),
    filePath: item.filePath || "",
    availableFields,
    missingFields,
  };

  try {
    const [putResponse, postResponse] = await Promise.all([
      axios.put(
        `${baseURL}/api/requested-data`,
        { profileId: id },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      ),
      fetch(`${baseURL}/api/send-request`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(requestData),
      }),
    ]);

    const result = await postResponse.json();

  } catch (error) {
    console.error("Error sending request:", error);
    Swal.fire({
      icon: "error",
      title: "Failed to Send Request",
      text: "There was a problem sending your request. Please try again.",
      confirmButtonColor: "#FCB124",
      confirmButtonText: "OK",
    });
  }
};

  // Update form data when admin fills input
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmitDetails = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");

    if (!token) {
      Swal.fire({
        icon: "error",
        title: "error",
        text: "You need to login first",
      });
      return;
    }

    if (!selectedRequest || !selectedRequest._id) {
      alert("No request selected!");
      return;
    }

    try {
      const response = await fetch(
        `${baseURL}/api/update-single-request/${selectedRequest._id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            requestedFields: formData,
            status: "Submitted",
          }),
        }
      );

      const result = await response.json();

      if (response.ok) {
        Swal.fire({
          icon: "success",
          title: "Request updated successfully!",
          confirmButtonColor: "FCB124",
          confirmButtonText: "Ok",
        });
        setFormData(
          result.updatedAdmin.singleRequests.find(
            (req) => req._id === selectedRequest._id
          )
        );
        setShowForm(false);
      } else {
        alert("Failed to update request: " + result.error);
      }
    } catch (error) {
      console.error("Error updating request:", error);
      alert("Error updating request");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setResearch((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };

  const handlelist = () => {
    if (selectedRows.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "No Selection",
        text: "Please select at least one user before creating a list.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
      return;
    }
    setShowlist(true);
  };

  const handleSave = async () => {
    if (!selectedRows.length) {
      Swal.fire({
        icon: "warning",
        title: "No Selection",
        text: "Please select at least one user.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
      return;
    }

    const token = localStorage.getItem("token");
    if (!token) {
      alert("You need to login first");
      return;
    }
    try {
      const response = await fetch(`${baseURL}/api/get-lists`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch existing lists");
      }

      const existingLists = await response.json();
      let finalListName = listName.trim();

      if (!finalListName) {
        let listCount = 1;

        if (existingLists.lists && Array.isArray(existingLists.lists)) {
          listCount = existingLists.lists.length + 1;
        }

        finalListName = `List ${listCount}`;
      }

      // Extract user data for selected rows
      const selectedUsers = selectedRows.map((id) =>
        data.find((user) => user._id === id)
      );

      const payload = {
        listName: finalListName,
        users: selectedUsers.map((user) => ({
          userid: user._id,
          firstname: user.firstname || "N/A",
          companyname: user.companyname || "N/A",
          email: user.email || "N/A",
          linkedin: user.linkedin || "",
          designation: user.designation || "",
          phonenumber: user.phonenumber || "",
          website: user.website || "",
          city: user.city || "",
          state: user.state || "",
          country: user.country || "",
          annualrevenue: user.annualrevenue || "",
          noofemployees: user.noofemployees || "",
          companylocation: user.companylocation || "",
          industry: user.industry || "",
          headquarter: user.headquarter || "",
          subcategory: user.subcategory || "",
          typeofCustomer: user.typeofCustomer || "",
          companydescription: user.companydescription || "",
          technologydetails: user.technologydetails || "",
          jobopenings: Array.isArray(user.jobopenings) ? user.jobopenings : [],
          newsandsocialinsights: Array.isArray(user.newsandsocialinsights)
            ? user.newsandsocialinsights
            : [],
          financial: Array.isArray(user.financial) ? user.financial : [],
          investors: Array.isArray(user.investors) ? user.investors : [],
          competitors: user.competitors || "",
          partners: user.partners || "",
        })),
      };

      const saveResponse = await fetch(`${baseURL}/api/add-list`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });
      const saveData = await saveResponse.json();
      if (saveResponse.ok) {
        Swal.fire({
          icon: "success",
          title: "List Created Successfully!",
          text: "Your new list has been created.",
          confirmButtonColor: "#FCB124",
          confirmButtonText: "Ok",
        });
        setList((prevLists) => [...prevLists, payload]);
        setShowlist(false);
        setListName("");
        setSelectedRows([]);
        setSelectAll();
      } else {
        alert(saveData.message || "Failed to create the list.");
      }
    } catch (error) {
      console.error("Error creating list:", error);
      alert("Error occurred while creating the list.");
    }
  };

  const handleOpenResearch = async (id) => {
    if (selectedRows.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "Please select one row!",
        text: "Please select only one row for research.",
        confirmButtonColor: "#FCB124",
      });
      return;
    }

    if (selectedRows.length > 1) {
      Swal.fire({
        icon: "warning",
        title: "Only one row allowed!",
        text: "Please select only one row for research.",
        confirmButtonColor: "#FCB124",
      });
      return;
    }

    if (remainingCredits === 0) {
      Swal.fire({
        icon: "warning",
        title: "No Remaining Credits",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
      return;
    }

    try {
      const response = await fetch(`${baseURL}/api/user/${listName}/${id}`);
      const data = await response.json();

      const allFieldsFilled =
        data.extraFields &&
        data.extraFields.length > 0 &&
        data.extraFields.every(
          (field) => field.value && field.value.trim() !== ""
        );

      if (
        allFieldsFilled ||
        (data.extraFields && data.extraFields.length > 0)
      ) {
        const result = await Swal.fire({
          title: allFieldsFilled
            ? "Research Request Completed"
            : "Research Request In Progress",
          text: "You already sent a research request. Do you want to modify it or add a new one?",
          icon: allFieldsFilled ? "info" : "warning",
          showCancelButton: true,
          confirmButtonText: "Modify",
          cancelButtonText: "New Request",
        });

        if (result.isConfirmed) {
          Swal.fire({
            icon: "info",
            title: "Modifications Restricted",
            text: "Modifications are restricted. Please contact the support team.",
            confirmButtonColor: "#FCB124",
          });
        } else {
          setResearch({ ...data });
          setIsResearch(true);
        }
      } else {
        setResearch({ ...data });
        setIsResearch(true);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
    setSelectedRows([]);
  };

  const handleFieldValueChange = (e, index) => {
    const { value } = e.target;
    setResearch((prevResearch) => {
      const updatedExtraFields = prevResearch.extraFields
        ? [...prevResearch.extraFields]
        : [];

      if (updatedExtraFields[index]) {
        updatedExtraFields[index].value = value;
      }

      return {
        ...prevResearch,
        extraFields: updatedExtraFields,
      };
    });
  };

  const handleLabelSubmit = async (e) => {
    if (e.key === "Enter" && newFieldLabel.trim()) {
      const updatedFields = research.extraFields?.length
        ? [...research.extraFields, { label: newFieldLabel, value: "" }]
        : [{ label: newFieldLabel, value: "" }];

      setResearch((prev) => ({
        ...prev,
        extraFields: updatedFields,
      }));

      setNewFieldLabel("");
      setShowLabelInput(false);

      try {
        const token = localStorage.getItem("token");
        await axios.put(
          `${baseURL}/api/update-research/${listName}/${research._id}`,
          { extraFields: updatedFields },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
      } catch (error) {
        console.error("Error updating extra fields:", error);
        alert("Failed to save extra fields.");
      }
    }
  };

  const handleBulkRequestData = async () => {
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("userId");
    const userName = localStorage.getItem("name");
    const userEmail = localStorage.getItem("email");

    if (!token) {
      Swal.fire({
        icon: "warning",
        title: "Access Denied",
        text: "You must log in first!",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
      return;
    }
    if (remainingCredits === 0) {
      Swal.fire({
        icon: "warning",
        title: "No Remaining Credits",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
      return;
    }

    if (!list || list.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "No data available for selection",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "Okay",
      });
      return;
    }

    if (selectedRows.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "Please select at least one contact to send a request.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "Ok",
      });
      return;
    }

    // Fields to check
    const requiredFields = [
      "technologydetails",
      "jobopenings",
      "newsandsocialinsights",
    ];

    // Prepare bulk request data
    const requestList = selectedRows
      .map((id) => {
        console.log(list)
        const item = currentUsers.find((company) => company._id === id);
        console.log(item);
        if (!item) {
          console.warn(
            `Invalid selection: ID ${id} not found in List.`
          );
          return null;
        }

        // Ensure fields are arrays or set them to empty arrays if undefined
        requiredFields.forEach((field) => {
          if (!Array.isArray(item[field])) {
            item[field] = [];
          }
        });

        // Check if at least one required field is missing
        const isDataMissing = requiredFields.some(
          (field) => item[field].length === 0
        );

        if (!isDataMissing) {
          console.warn(
            `Skipping ${item.companyname}: Some required data already exists.`
          );
          return null;
        }

        return {
          userId: item._id,
          listname: selectedListName,
          firstname: item.firstname || "",
          companyname: item.companyname || "",
          linkedin: item.linkedin || "",
          email: item.email || "",
          designation: item.designation || "",
          phonenumber: item.phonenumber || "",
          website: item.website || "",
          city: item.city || "",
          state: item.state || "",
          country: item.country || "",
          annualrevenue: item.annualrevenue || "",
          noofemployees: item.noofemployees || "",
          companylocation: item.companylocation || "",
          industry: item.industry || "",
          headquarter: item.headquarter || "",
          subcategory: item.subcategory || "",
          typeofCustomer: item.typeofCustomer || "",
          companydescription: item.companydescription || "",
          technologydetails: item.technologydetails || [],
          jobopenings: item.jobopenings || [],
          newsandsocialinsights: item.newsandsocialinsights || [],
          financial: item.financial || [],
          investors: item.investors || [],
          competitors: item.competitors || "",
          partners: item.partners || "",
          requestedFields: requiredFields,
        };
      })
      .filter(Boolean);
      console.log(requestList);
    if (requestList.length === 0) {
      Swal.fire({
        icon: "info",
        title: "No Requests Sent",
        text: "All selected companies already have Technology Details, Job Openings, and News & Insights.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
      return;
    }

    try {
      const response = await fetch(`${baseURL}/api/send-bulk-request`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          adminId,
          researcherId,
          userId,
          userName,
          userEmail,
          requests: requestList,
        }),
      });

      const result = await response.json();

      if (response.ok) {
        Swal.fire({
          icon: "success",
          title: "Request Sent",
          text: result.message || "Bulk request sent successfully.",
          confirmButtonColor: "#FCB124",
          confirmButtonText: "OK",
        });
        setSelectedRows([]);
        setSelectAll();
        if (remainingCredits > 0) {
          const updatedSpent = spentCredits + 1;
          const updatedRemaining = remainingCredits - 1;

          setSpentCredits(updatedSpent);
          setRemainingCredits(updatedRemaining);

          saveCreditsToDB(credits, updatedSpent, updatedRemaining);
        } else {
          Swal.fire({
            icon: "warning",
            title: "No Remaining Credits",
            confirmButtonColor: "#FCB124",
            confirmButtonText: "OK",
          });
          setSelectedRows([]);
          setSelectAll();
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "Request Failed",
          text: result.message || "Failed to send bulk request.",
          confirmButtonColor: "#FCB124",
          confirmButtonText: "OK",
        });
        setSelectedRows([]);
        setSelectAll();
      }
    } catch (error) {
      console.error("Error sending bulk request:", error);
      Swal.fire({
        icon: "error",
        title: "Network Error",
        text: "Please try again.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
      setSelectedRows([]);
      setSelectAll();
    }
  };


  const handleSendResearch = async (e) => {
    e.preventDefault();

    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("userId");
    const userName = localStorage.getItem("name");
    const userEmail = localStorage.getItem("email");

    if (!token) {
      Swal.fire({
        icon: "warning",
        title: "Access Denied",
        text: "You must log in first!",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
      return;
    }

    const requestData = {
      ...research,
      adminId,
      userId,
      userName,
      userEmail,
      matchId: research?._id || null,
    };

    try {
      const response = await fetch(`${baseURL}/api/research-data/:listName`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(requestData),
      });

      const responseData = await response.json();

      if (response.ok) {
        setResearch(responseData);
        setIsResearch(false);
        setSelectedRows([]);
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Research data sent successfully.",
          confirmButtonColor: "#FCB124",
          confirmButtonText: "OK",
        });
        if (remainingCredits > 0) {
          const updatedSpent = spentCredits + 1;
          const updatedRemaining = remainingCredits - 1;

          setSpentCredits(updatedSpent);
          setRemainingCredits(updatedRemaining);

          saveCreditsToDB(credits, updatedSpent, updatedRemaining);
        } else {
          Swal.fire({
            icon: "warning",
            title: "No Remaining Credits",
            confirmButtonColor: "#FCB124",
            confirmButtonText: "OK",
          });
        }
      } else {
        throw new Error(
          responseData.message || "Failed to send research data."
        );
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message || "Something went wrong. Please try again.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
      console.error("Request failed:", error);
    }
  };

  const handleSubmitResearch = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");

    if (!token) {
      Swal.fire({
        icon: "error",
        title: "You must log in first.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "Ok",
      });
      return;
    }

    try {
      const response = await axios.put(
        `${baseURL}/api/submit-research`,
        {
          userId: research.userId,
          matchId: research.matchId,
          extraFields: extraFields,
          status: "Submitted",
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        setResearch(response.data.data);
        Swal.fire({
          icon: "success",
          title: "Extra field updated successfully!",
          confirmButtonColor: "#FCB124",
          confirmButtonText: "Ok",
        });
        setIsResearch(false);
      } else {
        Swal.fire({
          icon: "error",
          title: "Error occurred while submitting details.",
          confirmButtonColor: "#FCB124",
          confirmButtonText: "Ok",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: error.response?.data?.message || "An error occurred.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "Ok",
      });
    }
  };

  return (
    <>
      <div>
        <Header
          setSearchData={setSearchData}
          credits={credits}
          setCredits={setCredits}
          spentCredits={spentCredits}
          setSpentCredits={setSpentCredits}
          remainingCredits={remainingCredits}
          setRemainingCredits={setRemainingCredits}
          saveCreditsToDB={saveCreditsToDB}
          userlists={userlists}
        />
      </div>
      <div className="companies-container">
         <SidebarFilter
            setSelectedList={setSelectedList}
            selectedList={selectedList}
            selectedListName={selectedListName}
            setSelectedListName={setSelectedListName}
            selectedFilters={selectedFilters}
            setSelectedFilters={setSelectedFilters}
            isMyContacts={isMyContacts}
            setIsMyContacts={setIsMyContacts}
            handleDisplayMyContacts={handleDisplayMyContacts}
            handleDisplayUserLists={handleDisplayUserLists}
            userlists={userlists}
            setuserlists={setuserlists}
            setIsContacts={setIsContacts}
            handleDisplayContacts={handleDisplayContacts}
            isContacts={isContacts}
          />
        <div className="companies">
          <div className="companies-top">
            <div className={`people-favorite`}></div>
          </div>
          <div className="companies-count">
            <div className="count">
              <div
                style={role === "user" ? { gap: "50px" } : { gap: "300px" }}
                className="crm-contacts"
              >
                <div className="crm-add-search">
                  <p>
                    {" "}
                    {selectedListName}
                    &nbsp;
                    <span style={{ fontSize: "24px" }}>
                      {filteredUsers ? filteredUsers.length: selectedUsersCount}
                    </span>
                  </p>
                  <div>
                    <button
                      className="crm-donld"
                      onClick={handleDownloadEntireListExcel}
                    >
                      <IoMdDownload />
                    </button>
                  </div>
                </div>
                <div className="crm-add-search">
                  <div>
                    <div className="company-btn">
                      <button
                        style={{
                          width: "100px",
                          height: "30px",
                          borderRadius: "5px",
                          color: "#FCB124",
                        }}
                        onClick={() => handleUpload()}
                      >
                        Bulk Upload
                      </button>
                      <input
                        className="input-upload"
                        type="file"
                        accept=".xlsx, .xls"
                        onChange={handleFileChange}
                      />
                    </div>
                    {uploadFile && (
                      <div className="upload-status">
                        <span style={{ fontSize: "12px" }}>✅</span>
                        <span style={{ fontSize: "12px" }}>
                          Ready to Upload!
                        </span>
                      </div>
                    )}
                  </div>
                  {list.length > 0 && (
                      <>
                        <div
                          className="crm-search"
                          onClick={() => handleBulkRequestData()}
                        >
                          <p
                            className="scoop-input"
                            style={{
                              fontSize: "14px",
                              color: "#000",
                              width: "110px",
                              cursor: "pointer",
                            }}
                          >
                            Enrich Scoop
                          </p>
                          <img
                            className="search-icon"
                            style={{ width: "20px", height: "15px" }}
                            src={idea1}
                            alt="scoop-img"
                          />
                        </div>
                        <div
                          onClick={() => {
                            if (isEnabled) handleOpenResearch(selectedUserId);
                          }}
                          style={{
                            cursor: isEnabled ? "pointer" : "default",
                            opacity: isEnabled ? 1 : 0.6,
                          }}
                          className="crm-search"
                        >
                          <p
                            className="scoop-input"
                            style={{
                              fontSize: "14px",
                              color: "#000",
                              width: "130px",
                              cursor: isEnabled ? "pointer" : "default",
                            }}
                          >
                            Research for me
                          </p>
                          <img
                            className="search-icon"
                            style={{ width: "20px", height: "15px" }}
                            src={idea1}
                            alt="scoop-img"
                          />
                        </div>
                      </>
                    )}
                </div>
              </div>
            </div>

            {isLoading? (
              <div className="spinner-container">
                <div className="loading-spinner"></div>
                <p style={{ marginTop: "10px", color: "#666" }}>Loading...</p>
              </div>
              ): (list && list.length) === 0 ? (
              <div
                style={{
                  textAlign: "center",
                  fontSize: "18px",
                  color: "#aaa",
                  marginTop: "100px",
                }}
              >
                <p>No data found</p>
                <p>Please upload an Excel file containing the data</p>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => (window.location.href = "/sample.xlsx")}
                >
                  <IoMdDownload /> Sample file
                </span>
              </div>
            ) : (
              <>
                  <div className="table-icons">
                  <div className="tablepagination">
                    {Array.isArray(list) && list.length > 0 ? (
                      <table className="company-table">
                        <thead>
                          <tr>
                            <th>
                              <input
                                type="checkbox"
                                checked={selectAll}
                                onChange={handleSelectAll}
                              />
                            </th>
                            {visibleColumns.firstname && <th>Name</th>}
                            {visibleColumns.companyname && (
                              <th>Company Name</th>
                            )}
                            {visibleColumns.designation && <th>Designation</th>}
                            <th>Scoop</th>
                            <th>Status</th>
                            <th>Updated by</th>
                            <th>Updated</th>
                          </tr>
                        </thead>
                        <tbody>
                         {Array.isArray(currentUsers) && currentUsers.length > 0 ? (
  currentUsers.map((user, index) => {
    const { src, alt, tooltip } = getImageData(user.status);

    return (
      <tr key={index}>
        <td>
          <input
            type="checkbox"
            value={user._id}
            checked={selectedRows.includes(user._id)}
            onChange={() => handleCheckboxChange(user._id)}
          />
        </td>

        <td className="name-linkedin">
          <span>
            <p>{user.firstname}</p>
          </span>
          {visibleColumns.linkedin && user.linkedin && (
            <a
              href={user.linkedin}
              target="_blank"
              rel="noreferrer noopener"
            >
              <FaLinkedin className="linkedin" />
            </a>
          )}
        </td>

        {visibleColumns.companyname && (
          <td
            style={{
              cursor: !viewedProfiles.includes(user._id)
                ? "default"
                : "pointer",
              position: "relative",
            }}
            className="expand"
          >
            <span
              className="scoop-fire"
              style={{ margin: "0px 5px" }}
            >
              <button
                onMouseOver={() => setHover(user._id)}
                onMouseLeave={() => setHover(false)}
                style={{
                  cursor: !viewedProfiles.includes(user._id)
                    ? "default"
                    : "pointer",
                  color: !viewedProfiles.includes(user._id)
                    ? "#000"
                    : "#FCB124",
                }}
                disabled={!viewedProfiles.includes(user._id)}
                onClick={() =>
                  handleDetailList(selectedListName, user._id)
                }
              >
                {user.companyname.length > 20
                  ? `${user.companyname.slice(0, 20)}...`
                  : user.companyname}
              </button>
              {hover === user.userid &&
                !viewedProfiles.includes(user._id) && (
                  <div
                    style={{
                      position: "absolute",
                      top: "40px",
                      left: "35%",
                      transform: "translateX(-50%)",
                      backgroundColor: "rgba(0, 0, 0, 0.8)",
                      color: "white",
                      padding: "8px",
                      borderRadius: "6px",
                      fontSize: "12px",
                      whiteSpace: "nowrap",
                      zIndex: 3,
                    }}
                  >
                    Buy scoop
                  </div>
                )}
            </span>
          </td>
        )}

        {visibleColumns.designation && (
          <td>
            {user.designation
              ? user.designation.length > 20
                ? `${user.designation.slice(0, 20)}...`
                : user.designation
              : "N/A"}
          </td>
        )}

        <td className="expand" style={{ position: "relative" }}>
          {(role === "researcher" || role === "admin" || role === "user") && (
            <>
              {(user.technologydetails ||
                (user.jobopenings &&
                  user.jobopenings.some(
                    (item) =>
                      item.jobname || item.jobdescription || item.jobsource
                  )) ||
                (user.newsandsocialinsights &&
                  user.newsandsocialinsights.some(
                    (item) =>
                      item.newsname ||
                      item.newsdescription ||
                      item.newssource
                  ))) ? (
                !viewedProfiles.includes(user._id) ? (
                  <div
                    onClick={() =>
                      handleOpenListProfile(selectedListName, user._id)
                    }
                  >
                    <span
                      className="scoop-fire-1"
                      style={{ margin: "0px 5px" }}
                    >
                      <IoLockOpen
                        onMouseOver={() => setScoopHover(user._id)}
                        onMouseLeave={() => setScoopHover(false)}
                      />
                      {scoopHover === user._id && (
                        <div
                          style={{
                            position: "absolute",
                            top: "40px",
                            left: "50%",
                            transform: "translateX(-50%)",
                            backgroundColor: "rgba(0, 0, 0, 0.8)",
                            color: "white",
                            padding: "8px",
                            borderRadius: "6px",
                            fontSize: "12px",
                            whiteSpace: "nowrap",
                            zIndex: 100,
                          }}
                        >
                          View scoop
                        </div>
                      )}
                    </span>
                  </div>
                ) : (
                  <span
                    className="scoop-fire-1"
                    style={{ margin: "0px 5px" }}
                  >
                    <GiCampfire
                      onClick={() =>
                        handleOpenListProfile(selectedListName, user._id)
                      }
                    />
                  </span>
                )
              ) : requestedData.includes(user._id || user.userid) ? (
                <span style={{ margin: "0px 5px", color: "gray" }}>
                  Requested
                </span>
              ) : (
                <span
                  onClick={() => handleRequestData(user)}
                  style={{ margin: "0px 5px" }}
                >
                  <button>Request</button>
                </span>
              )}
            </>
          )}
        </td>

        <td>
          {user.status === "Not Verified" ? (
            <img src={src} alt={alt} title={tooltip} className="verified-not-expire" />
          ) : user.status === "Verified" ? (
            <img src={src} alt={alt} title={tooltip} className="verified-not-expire" />
          ) : user.status === "Expiring" ? (
            <img src={src} alt={alt} title={tooltip} className="verified-not-expire" />
          ) : (
            <img src={src} alt={alt} title={tooltip} className="verified-not-expire" />
          )}
        </td>

        <td>
          {user.updatedByRole === "user"
            ? "You"
            : user.updatedByRole === "researcher"
            ? "Researcher"
            : "You"}
        </td>

        <td className="expand">
          <span className="scoop-fire" style={{ margin: "0px 5px" }}>
            <button>
              {user.updatedAt
                ? new Date(user.updatedAt)
                    .toLocaleDateString("en-GB")
                    .replace(/\//g, "-")
                : "N/A"}
            </button>
          </span>
        </td>
      </tr>
    );
  })
) : (
  <tr>
    <td colSpan="6">No data available</td>
  </tr>
)}

                        </tbody>
                      </table>
                    ) : (
                      <p>Select a list to view details</p>
                    )}
                    <div className="table-pagination">
                      <button
                        className="nav-button"
                        onClick={() => handlePageChange(currentListPage - 1)}
                        disabled={currentListPage === 1}
                      >
                        Prev
                      </button>

                      {(() => {
                        const pageButtons = [];
                        const maxVisible = 5;
                        let startPage = Math.max(1, currentListPage - 2);
                        let endPage = Math.min(
                          totalListPages,
                          startPage + maxVisible - 1
                        );

                        // Adjust startPage if we’re at the end
                        if (endPage - startPage < maxVisible - 1) {
                          startPage = Math.max(1, endPage - maxVisible + 1);
                        }

                        for (let i = startPage; i <= endPage; i++) {
                          pageButtons.push(
                            <button
                              key={i}
                              className={
                                currentListPage === i ? "active-page" : ""
                              }
                              onClick={() => goToListPage(i)}
                              style={{
                                fontWeight:
                                  currentListPage === i ? "bold" : "normal",
                                margin: "5px",
                              }}
                            >
                              {i}
                            </button>
                          );
                        }

                        return pageButtons;
                      })()}

                      {/* Dots if more pages exist */}
                      {currentListPage + 2 < totalListPages && (
                        <span style={{ margin: "0 10px" }}>...</span>
                      )}

                      <button
                        className="nav-button"
                        onClick={() => handlePageChange(currentListPage + 1)}
                        disabled={currentListPage === totalListPages}
                      >
                        Next
                      </button>
                    </div>
                  </div>
                  <div className="crm-icons">
                    <div className="crm-search">
                      {((role === "user" && userlists) ||
                        (role === "admin")) && (
                        <button
                          className="crm-add"
                          onClick={() => {
                            setIsAddList(true);
                          }}
                        >
                          <FaPlus />
                        </button>
                      )}
                    </div>
                    <div className="crm-search">
                      <button
                        className="crm-download"
                        onClick={handleDownloadListExcel}
                      >
                        <IoMdDownload />
                      </button>
                    </div>

                    <div className="crm-search">
                      {((role === "user" && userlists) ||
                        (role === "admin")) && (
                        <button
                          className="crm-delete"
                          onClick={handleDeleteList}
                        >
                          <MdDelete />
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
          {showForm && selectedRequest && (
            <div className="add-popup">
              <div
                className="overlay"
                onClick={() => {
                  setShowForm(false);
                }}
              ></div>
              <div className="add-popup-box">
                <div className="add-heading">
                  <button
                    className="popup-close"
                    onClick={() => {
                      setShowForm(false);
                    }}
                  >
                    X
                  </button>
                  <h4>Update missing fields</h4>
                </div>
                <form className="form-container" onSubmit={handleSubmitDetails}>
                  <div className="input-container-flex">
                    <div className="input-container">
                      <label htmlFor="name">First Name</label>
                      <input
                        type="text"
                        name="firstname"
                        placeholder="Enter name"
                        value={formData.firstname}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div className="input-container">
                      <label htmlFor="name">Company Name</label>
                      <input
                        type="text"
                        name="companyname"
                        placeholder="Enter company name"
                        value={formData.companyname}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>
                  <div className="input-container-flex">
                    <div className="input-container">
                      <label htmlFor="linkedin">Linkedin Link</label>
                      <input
                        type="text"
                        name="linkedin"
                        placeholder="Enter linkedin link"
                        value={formData.linkedin}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div className="input-container">
                      <label htmlFor="name">Email</label>
                      <input
                        type="email"
                        name="email"
                        placeholder="Enter email"
                        value={formData.email}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>

                  <div className="input-container-flex">
                    <div className="input-container">
                      <label htmlFor="designation">Designation</label>
                      <input
                        type="text"
                        name="designation"
                        placeholder="Designation"
                        value={formData.designation}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div className="input-container">
                      <label htmlFor="phonenumber">Phone Number</label>
                      <input
                        type="number"
                        name="phonenumber"
                        placeholder="Phone Number"
                        value={formData.phonenumber}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>
                  <div className="input-container-flex">
                    <div className="input-container">
                      <label htmlFor="website">Website</label>
                      <input
                        type="text"
                        name="website"
                        placeholder="Website Link"
                        value={formData.website}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div className="input-container">
                      <label htmlFor="designation">Company description</label>
                      <textarea
                        type="text"
                        name="companydescription"
                        placeholder="Company Description"
                        value={formData.companydescription}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>

                  <div className="input-container-flex">
                    <div className="input-container">
                      <label htmlFor="designation">City</label>
                      <input
                        type="text"
                        name="city"
                        placeholder="City"
                        value={formData.city}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div className="input-container">
                      <label htmlFor="phonenumber">State</label>
                      <input
                        type="text"
                        name="state"
                        placeholder="State"
                        value={formData.state}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>

                  <div className="input-container-flex">
                    <div className="input-container">
                      <label htmlFor="country">Country</label>
                      <input
                        type="text"
                        name="country"
                        placeholder="Country"
                        value={formData.country}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div className="input-container">
                      <label htmlFor="phonenumber">Industry</label>
                      <input
                        type="text"
                        name="industry"
                        placeholder="Industry"
                        value={formData.industry}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>

                  <div className="input-container-flex">
                    <div className="input-container">
                      <label htmlFor="designation">Annual Revenue</label>
                      <input
                        type="text"
                        name="annualrevenue"
                        placeholder="Annual Revenue"
                        value={formData.annualrevenue}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div className="input-container">
                      <label htmlFor="phonenumber">No of Employees</label>
                      <input
                        type="number"
                        name="noofemployees"
                        placeholder="Employees"
                        value={formData.noofemployees}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>

                  <div className="input-container-flex">
                    <div className="input-container">
                      <label htmlFor="companylocation">Company Location</label>
                      <input
                        type="text"
                        name="companylocation"
                        placeholder="Company location"
                        value={formData.companylocation}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div className="input-container">
                      <label htmlFor="designation">Headquarters</label>
                      <input
                        type="text"
                        name="headquarter"
                        placeholder="Head Quarter"
                        value={formData.headquarter}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>

                  <div className="input-container-flex">
                    <div className="input-container">
                      <label htmlFor="designation">Sub category</label>
                      <input
                        type="text"
                        name="subcategory"
                        placeholder="Sub category"
                        value={formData.subcategory}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div className="input-container">
                      <label htmlFor="phonenumber">Type of Customer</label>
                      <input
                        type="text"
                        name="typeofCustomer"
                        placeholder="Type of customer"
                        value={formData.typeofCustomer}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>

                  <div className="input-container-flex">
                    <div className="input-container">
                      <label htmlFor="designation">Financial</label>
                      {formData.financial.map((finance, index) => (
                        <div
                          key={index}
                          className="input-container-flex"
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "3px",
                          }}
                        >
                          <button
                            type="button"
                            className="remove-button"
                            onClick={() => removeFinancialForm(index)}
                            style={{
                              alignSelf: "flex-end",
                              cursor: "pointer",
                              border: "none",
                            }}
                          >
                            X
                          </button>
                          <input
                            type="text"
                            name="financialdescription"
                            placeholder="Financial Description"
                            value={finance.financialdescription}
                            onChange={(e) =>
                              handleFinanceFormChange(
                                e,
                                index,
                                "financialdescription"
                              )
                            }
                          />
                          <input
                            type="text"
                            name="financialyear"
                            placeholder="Financial Year"
                            value={finance.financialyear}
                            onChange={(e) =>
                              handleFinanceFormChange(e, index, "financialyear")
                            }
                          />
                          <input
                            type="text"
                            name="financialsourcelink"
                            placeholder="Financial"
                            value={finance.financialsourcelink}
                            onChange={(e) =>
                              handleFinanceFormChange(
                                e,
                                index,
                                "financialsourcelink"
                              )
                            }
                          />
                        </div>
                      ))}
                      <button
                        type="button"
                        className="add-more-field"
                        onClick={addFinancialForm}
                      >
                        + Add More
                      </button>
                    </div>
                    <div className="input-container">
                      <label htmlFor="phonenumber">Investors</label>
                      {formData.investors.map((invest, index) => (
                        <div
                          key={index}
                          className="input-container-flex"
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "3px",
                          }}
                        >
                          <button
                            type="button"
                            className="remove-button"
                            onClick={() => removeInvestorForm(index)}
                            style={{
                              alignSelf: "flex-end",
                              cursor: "pointer",
                              border: "none",
                            }}
                          >
                            X
                          </button>
                          <input
                            type="text"
                            name="investors"
                            placeholder="Investors"
                            value={invest.investors}
                            onChange={(e) =>
                              handleInvestorFormChange(e, index, "investors")
                            }
                          />
                          <input
                            type="text"
                            name="investors"
                            placeholder="Investors"
                            value={invest.investorsourcelink}
                            onChange={(e) =>
                              handleInvestorFormChange(
                                e,
                                index,
                                "investorsourcelink"
                              )
                            }
                          />
                        </div>
                      ))}
                      <button
                        type="button"
                        className="add-more-field"
                        onClick={addInvestorForm}
                      >
                        + Add More
                      </button>
                    </div>
                  </div>

                  <div className="input-container-flex">
                    <div className="input-container">
                      <label htmlFor="designation">Competitors</label>
                      <input
                        type="text"
                        name="competitors"
                        placeholder="competitors"
                        value={formData.competitors}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div className="input-container">
                      <label htmlFor="partner">Partners</label>
                      <input
                        type="text"
                        name="partners"
                        placeholder="Partners"
                        value={formData.partners}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>
                  <div className="input-container-flex">
                    <div className="input-container">
                      <label htmlFor="technologydetails">
                        Technology Details
                        <span style={{ color: "red", margin: "0px 2px" }}>
                          *
                        </span>
                      </label>
                      <input
                        type="text"
                        name="technologydetails"
                        placeholder="Technology details"
                        value={formData.technologydetails}
                        onChange={handleInputChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="input-container-flex">
                    <div className="input-container">
                      <label htmlFor="jobopenings">
                        Job Openings
                        <span style={{ color: "red", margin: "0px 2px" }}>
                          *
                        </span>
                      </label>
                      {formData.jobopenings.map((job, index) => (
                        <div
                          key={index}
                          className="input-container-flex"
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "3px",
                          }}
                        >
                          {formData.newsandsocialinsights.length > 1 && (
                            <button
                              type="button"
                              className="remove-button"
                              onClick={() => removeJobOpeningForm(index)}
                              style={{
                                alignSelf: "flex-end",
                                cursor: "pointer",
                                border: "none",
                              }}
                            >
                              X
                            </button>
                          )}
                          <input
                            type="text"
                            name="jobname"
                            placeholder="Job Title"
                            value={job.jobname}
                            onChange={(e) =>
                              handleJobFormChange(e, index, "jobname")
                            }
                            required
                          />
                          <input
                            type="text"
                            name="jobdescription"
                            placeholder="Job Description"
                            value={job.jobdescription}
                            onChange={(e) =>
                              handleJobFormChange(e, index, "jobdescription")
                            }
                            required
                          />
                          <input
                            type="text"
                            name="jobsource"
                            placeholder="Job Link"
                            value={job.jobsource}
                            onChange={(e) =>
                              handleJobFormChange(e, index, "jobsource")
                            }
                            required
                          />
                        </div>
                      ))}
                      <button
                        type="button"
                        className="add-more-field"
                        onClick={addJobOpeningForm}
                      >
                        + Add More
                      </button>
                    </div>
                    <div className="input-container">
                      <label htmlFor="newsandsocialinsights">
                        News and Social Insights
                        <span style={{ color: "red", margin: "0px 2px" }}>
                          *
                        </span>
                      </label>
                      {formData.newsandsocialinsights.map((news, index) => (
                        <div
                          key={index}
                          className="input-container-flex"
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "3px",
                          }}
                        >
                          {formData.newsandsocialinsights.length > 1 && (
                            <button
                              type="button"
                              className="remove-button"
                              onClick={() => removeNewsForm(index)}
                              style={{
                                alignSelf: "flex-end",
                                cursor: "pointer",
                                border: "none",
                              }}
                            >
                              X
                            </button>
                          )}
                          <input
                            type="text"
                            name="newsname"
                            placeholder="News Title"
                            value={news.newsname}
                            onChange={(e) =>
                              handleNewsFormChange(e, index, "newsname")
                            }
                            required
                          />
                          <input
                            type="text"
                            name="newsdescription"
                            placeholder="News Description"
                            value={news.newsdescription}
                            onChange={(e) =>
                              handleNewsFormChange(e, index, "newsdescription")
                            }
                            required
                          />
                          <input
                            type="text"
                            name="newssource"
                            placeholder="News Source"
                            value={news.newssource}
                            onChange={(e) =>
                              handleNewsFormChange(e, index, "newssource")
                            }
                            required
                          />
                        </div>
                      ))}
                      <button
                        type="button"
                        className="add-more-field"
                        onClick={addNewsForm}
                      >
                        + Add More
                      </button>
                    </div>
                  </div>
                  <div className="button-action">
                    <button
                      className="close-button"
                      onClick={() => setShowForm(false)}
                    >
                      Close
                    </button>
                    {role === "researcher" && (
                      <button className="add-button" type="submit">
                        Submit
                      </button>
                    )}
                  </div>
                </form>
              </div>
            </div>
          )}

          {showMissingFieldsPopup && (
            <div className="popup-overlay">
              <div className="popup">
                <h2>⚠️ Missing Required Fields</h2>
                <p>The following required fields are missing:</p>
                <ul>
                  {missingFields.map((field, index) => (
                    <li key={index}>{field}</li>
                  ))}
                </ul>
                <div className="popup-buttons-upload">
                  <button onClick={handleCancelUpload}>Cancel</button>
                  <button onClick={handleProceedUpload}>Proceed</button>
                </div>
              </div>
            </div>
          )}

          {showPopup && (
            <div className="upload-popup">
              <div
                className="popup-overlay"
                onClick={() => setShowPopup(false)}
              >
                <div
                  className="popup-grid"
                  onClick={(e) => e.stopPropagation()}
                >
                  <button
                    className="popup-close"
                    onClick={() => setShowPopup(false)}
                  >
                    X
                  </button>
                  <h2 className="revenuintel-matching">Revenuintel</h2>
                  {/* Table-like Matching Layout */}
                  <div className="matching-container">
                    {excelHeaders.map((uploadedHeader, index) => (
                      <div key={index} className="matching-row">
                        <span className="uploaded-header">
                          {uploadedHeader}
                        </span>
                        <span className="match-arrow">→</span>
                        <select
                          value={selectedFields[uploadedHeader] || ""}
                          onChange={(e) =>
                            handleMappingChange(uploadedHeader, e.target.value)
                          }
                        >
                          <option value="">Select Header</option>
                          {requiredHeaders.map((requiredHeader, idx) => {
                            // Check if this header is already selected
                            const isSelected =
                              Object.values(selectedFields).includes(
                                requiredHeader
                              );

                            return (
                              <option
                                key={idx}
                                value={requiredHeader}
                                disabled={isSelected}
                              >
                                {requiredHeader}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    ))}
                  </div>
                  <button
                    className="popup-submit"
                    onClick={handleCheckMissingFields}
                  >
                    Apply Mapping
                  </button>
                </div>
              </div>
            </div>
          )}

          {(isAddList || editModeList) && (
            <div className="add-popup">
              <div
                className="overlay"
                onClick={() => {
                  setIsAddList(false);
                  setEditModeList(false);
                }}
              ></div>
              <div className="add-popup-box">
                <div className="add-heading">
                  <button
                    className="popup-close"
                    onClick={() => {
                      setIsAddList(false);
                      setEditModeList(false);
                    }}
                  >
                    X
                  </button>
                  <h4>Add Company Details</h4>
                </div>
                <form className="form-container" onSubmit={handleSavelist}>
                  <div className="input-container-flex">
                    <div className="input-container">
                      <label htmlFor="name">First Name</label>
                      <input
                        className="input"
                        type="text"
                        name="firstname"
                        placeholder="Enter name"
                        value={details.firstname}
                        onChange={handleOnChange}
                      />
                    </div>
                    <div className="input-container">
                      <label htmlFor="name">Company Name</label>
                      <input
                        className="input"
                        type="text"
                        name="companyname"
                        placeholder="Enter company name"
                        value={details.companyname}
                        onChange={handleOnChange}
                      />
                    </div>
                  </div>
                  <div className="input-container-flex">
                    <div className="input-container">
                      <label htmlFor="linkedin">Linkedin Link</label>
                      <input
                        className="input"
                        type="text"
                        name="linkedin"
                        placeholder="Enter linkedin link"
                        value={details.linkedin}
                        onChange={handleOnChange}
                      />
                    </div>
                    <div className="input-container">
                      <label htmlFor="name">Email</label>
                      <input
                        className="input"
                        type="email"
                        name="email"
                        placeholder="Enter email"
                        value={details.email}
                        onChange={handleOnChange}
                      />
                    </div>
                  </div>
                  <div className="input-container-flex">
                    <div className="input-container">
                      <label htmlFor="designation">Designation</label>
                      <input
                        className="input"
                        type="text"
                        name="designation"
                        placeholder="Designation"
                        value={details.designation}
                        onChange={handleOnChange}
                      />
                    </div>
                    <div className="input-container">
                      <label htmlFor="phonenumber">Phone Number</label>
                      <input
                        className="input"
                        type="number"
                        name="phonenumber"
                        placeholder="Phone Number"
                        value={details.phonenumber}
                        onChange={handleOnChange}
                      />
                    </div>
                  </div>
                  <div className="input-container-flex">
                    <div className="input-container">
                      <label htmlFor="website">Website</label>
                      <input
                        className="input"
                        type="text"
                        name="website"
                        placeholder="Website Link"
                        value={details.website}
                        onChange={handleOnChange}
                      />
                    </div>
                    <div className="input-container">
                      <label htmlFor="designation">Company description</label>
                      <textarea
                        className="form-textarea"
                        type="text"
                        name="companydescription"
                        placeholder="Company Description"
                        value={details.companydescription}
                        onChange={handleOnChange}
                      />
                    </div>
                  </div>

                  <div className="input-container-flex">
                    <div className="input-container">
                      <label htmlFor="designation">City</label>
                      <input
                        className="input"
                        type="text"
                        name="city"
                        placeholder="City"
                        value={details.city}
                        onChange={handleOnChange}
                      />
                    </div>
                    <div className="input-container">
                      <label htmlFor="phonenumber">State</label>
                      <input
                        className="input"
                        type="text"
                        name="state"
                        placeholder="State"
                        value={details.state}
                        onChange={handleOnChange}
                      />
                    </div>
                  </div>

                  <div className="input-container-flex">
                    <div className="input-container">
                      <label htmlFor="country">Country</label>
                      <input
                        className="input"
                        type="text"
                        name="country"
                        placeholder="Country"
                        value={details.country}
                        onChange={handleOnChange}
                      />
                    </div>
                    <div className="input-container">
                      <label htmlFor="phonenumber">Industry</label>
                      <input
                        className="input"
                        type="text"
                        name="industry"
                        placeholder="Industry"
                        value={details.industry}
                        onChange={handleOnChange}
                      />
                    </div>
                  </div>

                  <div className="input-container-flex">
                    <div className="input-container">
                      <label htmlFor="designation">Annual Revenue</label>
                      <input
                        className="input"
                        type="text"
                        name="annualrevenue"
                        placeholder="Annual Revenue"
                        value={details.annualrevenue}
                        onChange={handleOnChange}
                      />
                    </div>
                    <div className="input-container">
                      <label htmlFor="phonenumber">No of Employees</label>
                      <input
                        className="input"
                        type="number"
                        name="noofemployees"
                        placeholder="Employees"
                        value={details.noofemployees}
                        onChange={handleOnChange}
                      />
                    </div>
                  </div>

                  <div className="input-container-flex">
                    <div className="input-container">
                      <label htmlFor="companylocation">Company Location</label>
                      <input
                        className="input"
                        type="text"
                        name="companylocation"
                        placeholder="Company location"
                        value={details.companylocation}
                        onChange={handleOnChange}
                      />
                    </div>
                    <div className="input-container">
                      <label htmlFor="designation">Headquarters</label>
                      <input
                        className="input"
                        type="text"
                        name="headquarter"
                        placeholder="Head Quarter"
                        value={details.headquarter}
                        onChange={handleOnChange}
                      />
                    </div>
                  </div>

                  <div className="input-container-flex">
                    <div className="input-container">
                      <label htmlFor="designation">Sub category</label>
                      <input
                        className="input"
                        type="text"
                        name="subcategory"
                        placeholder="Sub category"
                        value={details.subcategory}
                        onChange={handleOnChange}
                      />
                    </div>
                    <div className="input-container">
                      <label htmlFor="phonenumber">Type of Customer</label>
                      <input
                        className="input"
                        type="text"
                        name="typeofCustomer"
                        placeholder="Type of customer"
                        value={details.typeofCustomer}
                        onChange={handleOnChange}
                      />
                    </div>
                  </div>

                  <div className="input-container-flex">
                    <div className="input-container">
                      <label htmlFor="designation">Financial</label>
                      {details.financial.map((finance, index) => (
                        <div
                          key={index}
                          className="input-container-flex"
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "3px",
                          }}
                        >
                          <button
                            type="button"
                            className="remove-button"
                            onClick={() => removeFinancial(index)}
                            style={{
                              alignSelf: "flex-end",
                              cursor: "pointer",
                              border: "none",
                            }}
                          >
                            X
                          </button>
                          <input
                            className="input"
                            type="text"
                            name="financialdescription"
                            placeholder="Financial"
                            value={finance.financialdescription}
                            onChange={(e) =>
                              handleFinanceChange(
                                e,
                                index,
                                "financialdescription"
                              )
                            }
                          />
                          <input
                            className="input"
                            type="text"
                            name="financialyear"
                            placeholder="Financial Description"
                            value={finance.financialyear}
                            onChange={(e) =>
                              handleFinanceChange(e, index, "financialyear")
                            }
                          />
                          <input
                            className="input"
                            type="text"
                            name="financialsourcelink"
                            placeholder="Financial Year"
                            value={finance.financialsourcelink}
                            onChange={(e) =>
                              handleFinanceChange(
                                e,
                                index,
                                "financialsourcelink"
                              )
                            }
                          />
                        </div>
                      ))}
                      <button
                        type="button"
                        className="add-more-field"
                        onClick={addFinancial}
                      >
                        + Add More
                      </button>
                    </div>
                    <div className="input-container">
                      <label htmlFor="phonenumber">Investors</label>
                      {details.investors.map((invest, index) => (
                        <div
                          key={index}
                          className="input-container-flex"
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "3px",
                          }}
                        >
                          <button
                            type="button"
                            className="remove-button"
                            onClick={() => removeInvestor(index)}
                            style={{
                              alignSelf: "flex-end",
                              cursor: "pointer",
                              border: "none",
                            }}
                          >
                            X
                          </button>
                          <input
                            className="input"
                            type="text"
                            name="investors"
                            placeholder="Investors"
                            value={invest.investors}
                            onChange={(e) =>
                              handleInvestorChange(e, index, "investors")
                            }
                          />
                          <input
                            className="input"
                            type="text"
                            name="investors"
                            placeholder="Investors"
                            value={invest.investorsourcelink}
                            onChange={(e) =>
                              handleInvestorChange(
                                e,
                                index,
                                "investorsourcelink"
                              )
                            }
                          />
                        </div>
                      ))}
                      <button
                        type="button"
                        className="add-more-field"
                        onClick={addInvestor}
                      >
                        + Add More
                      </button>
                    </div>
                  </div>

                  <div className="input-container-flex">
                    <div className="input-container">
                      <label htmlFor="designation">Competitors</label>
                      <input
                        className="input"
                        type="text"
                        name="competitors"
                        placeholder="competitors"
                        value={details.competitors}
                        onChange={handleOnChange}
                      />
                    </div>
                    <div className="input-container">
                      <label htmlFor="partner">Partners</label>
                      <input
                        className="input"
                        type="text"
                        name="partners"
                        placeholder="Partners"
                        value={details.partners}
                        onChange={handleOnChange}
                      />
                    </div>
                  </div>
                  <div className="input-container-flex">
                    <div className="input-container">
                      <label htmlFor="followers">Followers</label>
                      <input
                        className="input"
                        type="text"
                        name="followers"
                        placeholder="Followers"
                        value={details.followers}
                        onChange={handleOnChange}
                      />
                    </div>
                    <div className="input-container">
                      <label htmlFor="technologydetails">
                        Technology Details
                      </label>
                      <input
                        className="input"
                        type="text"
                        name="technologydetails"
                        placeholder="Technology Details"
                        value={details.technologydetails}
                        onChange={handleOnChange}
                      />
                    </div>
                  </div>
                  <div className="input-container-flex">
                    <div className="input-container">
                      <label htmlFor="jobopenings">Job Openings</label>
                      {details.jobopenings.map((job, index) => (
                        <div
                          key={index}
                          className="input-container-flex"
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "3px",
                          }}
                        >
                          <button
                            type="button"
                            className="remove-button"
                            onClick={() => removeJobOpening(index)}
                            style={{
                              alignSelf: "flex-end",
                              cursor: "pointer",
                              border: "none",
                            }}
                          >
                            X
                          </button>
                          <input
                            className="input"
                            type="text"
                            name="jobname"
                            placeholder="Job Title"
                            value={job.jobname}
                            onChange={(e) =>
                              handleJobChange(e, index, "jobname")
                            }
                          />
                          <input
                            className="input"
                            type="text"
                            name="jobdescription"
                            placeholder="Job Description"
                            value={job.jobdescription}
                            onChange={(e) =>
                              handleJobChange(e, index, "jobdescription")
                            }
                          />
                          <input
                            className="input"
                            type="text"
                            name="jobsource"
                            placeholder="Job Link"
                            value={job.jobsource}
                            onChange={(e) =>
                              handleJobChange(e, index, "jobsource")
                            }
                          />
                        </div>
                      ))}
                      <button
                        type="button"
                        className="add-more-field"
                        onClick={addJobOpening}
                      >
                        + Add More
                      </button>
                    </div>
                    <div className="input-container">
                      <label htmlFor="newsandsocialinsights">
                        News and Social Insights
                      </label>
                      {details.newsandsocialinsights.map((news, index) => (
                        <div
                          key={index}
                          className="input-container-flex"
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "3px",
                          }}
                        >
                          <button
                            type="button"
                            className="remove-button"
                            onClick={() => removeNews(index)}
                            style={{
                              alignSelf: "flex-end",
                              cursor: "pointer",
                              border: "none",
                            }}
                          >
                            X
                          </button>
                          <input
                            className="input"
                            type="text"
                            name="newsname"
                            placeholder="News Title"
                            value={news.newsname}
                            onChange={(e) =>
                              handleNewsChange(e, index, "newsname")
                            }
                          />
                          <input
                            className="input"
                            type="text"
                            name="newsdescription"
                            placeholder="News Description"
                            value={news.newsdescription}
                            onChange={(e) =>
                              handleNewsChange(e, index, "newsdescription")
                            }
                          />
                          <input
                            className="input"
                            type="text"
                            name="newssource"
                            placeholder="News Source"
                            value={news.newssource}
                            onChange={(e) =>
                              handleNewsChange(e, index, "newssource")
                            }
                          />
                        </div>
                      ))}
                      <button
                        type="button"
                        className="add-more-field"
                        onClick={addNews}
                      >
                        + Add More
                      </button>
                    </div>
                  </div>
                  <div className="button-action">
                    <button
                      className="close-button"
                      onClick={(e) => {
                        e.preventDefault();
                        setIsAddList(false);
                        setEditModeList(false);
                      }}
                    >
                      Close
                    </button>
                    <button className="add-button" type="submit">
                      {editModeList ? "Update" : "Add"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}

          {isResearch && (
            <div className="add-popup">
              <div
                className="overlay"
                onClick={() => {
                  setIsResearch(false);
                }}
              ></div>
              <div className="add-popup-box">
                <div className="add-heading">
                  <button
                    className="popup-close"
                    onClick={() => setIsResearch(false)}
                  >
                    X
                  </button>
                  <h4>Add Fields for Research</h4>
                </div>
                <form
                  className="form-container"
                  onSubmit={(e) => handleSubmitResearch(e)}
                >
                  <div className="input-container-flex">
                    <div className="input-container">
                      <label htmlFor="name">First Name</label>
                      <input
                        type="text"
                        name="firstname"
                        placeholder="Enter name"
                        value={research.firstname}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="input-container">
                      <label htmlFor="name">Company Name</label>
                      <input
                        type="text"
                        name="companyname"
                        placeholder="Enter company name"
                        value={research.companyname}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="input-container-flex">
                    <div className="input-container">
                      <label htmlFor="linkedin">Linkedin Link</label>
                      <input
                        type="text"
                        name="linkedin"
                        placeholder="Enter linkedin link"
                        value={research.linkedin}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="input-container">
                      <label htmlFor="name">Email</label>
                      <input
                        type="email"
                        name="email"
                        placeholder="Enter email"
                        value={research.email}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="input-container-flex">
                    <div className="input-container">
                      <label htmlFor="designation">Designation</label>
                      <input
                        type="text"
                        name="designation"
                        placeholder="Designation"
                        value={research.designation}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="input-container">
                      <label htmlFor="phonenumber">Phone Number</label>
                      <input
                        type="number"
                        name="phonenumber"
                        placeholder="Phone Number"
                        value={research.phonenumber}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="input-container-flex">
                    <div className="input-container">
                      <label htmlFor="website">Website</label>
                      <input
                        type="text"
                        name="website"
                        placeholder="Website Link"
                        value={research.website}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="input-container">
                      <label htmlFor="designation">Company description</label>
                      <textarea
                        type="text"
                        name="companydescription"
                        placeholder="Company Description"
                        value={research.companydescription}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="input-container-flex">
                    <div className="input-container">
                      <label htmlFor="designation">City</label>
                      <input
                        type="text"
                        name="city"
                        placeholder="City"
                        value={research.city}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="input-container">
                      <label htmlFor="phonenumber">State</label>
                      <input
                        type="text"
                        name="state"
                        placeholder="State"
                        value={research.state}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="input-container-flex">
                    <div className="input-container">
                      <label htmlFor="country">Country</label>
                      <input
                        type="text"
                        name="country"
                        placeholder="Country"
                        value={research.country}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="input-container">
                      <label htmlFor="phonenumber">Industry</label>
                      <input
                        type="text"
                        name="industry"
                        placeholder="Industry"
                        value={research.industry}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="input-container-flex">
                    <div className="input-container">
                      <label htmlFor="designation">Annual Revenue</label>
                      <input
                        type="text"
                        name="annualrevenue"
                        placeholder="Annual Revenue"
                        value={research.annualrevenue}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="input-container">
                      <label htmlFor="phonenumber">No of Employees</label>
                      <input
                        type="number"
                        name="noofemployees"
                        placeholder="Employees"
                        value={research.noofemployees}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="input-container-flex">
                    <div className="input-container">
                      <label htmlFor="companylocation">Company Location</label>
                      <input
                        type="text"
                        name="companylocation"
                        placeholder="Company location"
                        value={research.companylocation}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="input-container">
                      <label htmlFor="designation">Headquarters</label>
                      <input
                        type="text"
                        name="headquarter"
                        placeholder="Head Quarter"
                        value={research.headquarter}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="input-container-flex">
                    <div className="input-container">
                      <label htmlFor="designation">Sub category</label>
                      <input
                        type="text"
                        name="subcategory"
                        placeholder="Sub category"
                        value={research.subcategory}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="input-container">
                      <label htmlFor="phonenumber">Type of Customer</label>
                      <input
                        type="text"
                        name="typeofCustomer"
                        placeholder="Type of customer"
                        value={research.typeofCustomer}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="input-container-flex">
                    <div className="input-container">
                      <label htmlFor="designation">Financial</label>
                      {research?.financial?.map((finance, index) => (
                        <div
                          key={index}
                          className="input-container-flex"
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "3px",
                          }}
                        >
                          <br />
                          <input
                            type="text"
                            name="financialdescription"
                            placeholder="Financial"
                            value={finance.financialdescription}
                            onChange={(e) =>
                              handleFinanceChange(
                                e,
                                index,
                                "financialdescription"
                              )
                            }
                          />
                          <input
                            type="text"
                            name="financialyear"
                            placeholder="Financial Description"
                            value={finance.financialyear}
                            onChange={(e) =>
                              handleFinanceChange(e, index, "financialyear")
                            }
                          />
                          <input
                            type="text"
                            name="financialsourcelink"
                            placeholder="Financial Year"
                            value={finance.financialsourcelink}
                            onChange={(e) =>
                              handleFinanceChange(
                                e,
                                index,
                                "financialsourcelink"
                              )
                            }
                          />
                        </div>
                      ))}
                      <button
                        type="button"
                        className="add-more-field"
                        onClick={addFinancial}
                      >
                        + Add More
                      </button>
                    </div>
                    <div className="input-container">
                      <label htmlFor="phonenumber">Investors</label>
                      {research?.investors?.map((invest, index) => (
                        <div
                          key={index}
                          className="input-container-flex"
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "3px",
                          }}
                        >
                          <br />
                          <input
                            type="text"
                            name="investors"
                            placeholder="Investors"
                            value={invest.investors}
                            onChange={(e) =>
                              handleInvestorChange(e, index, "investors")
                            }
                          />
                          <input
                            type="text"
                            name="investors"
                            placeholder="Investors"
                            value={invest.investorsourcelink}
                            onChange={(e) =>
                              handleInvestorChange(
                                e,
                                index,
                                "investorsourcelink"
                              )
                            }
                          />
                        </div>
                      ))}
                      <button
                        type="button"
                        className="add-more-field"
                        onClick={addInvestor}
                      >
                        + Add More
                      </button>
                    </div>
                  </div>

                  <div className="input-container-flex">
                    <div className="input-container">
                      <label htmlFor="designation">Competitors</label>
                      <input
                        type="text"
                        name="competitors"
                        placeholder="competitors"
                        value={research.competitors}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="input-container">
                      <label htmlFor="partner">Partners</label>
                      <input
                        type="text"
                        name="partners"
                        placeholder="Partners"
                        value={research.partners}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="input-container-flex">
                    <div className="input-container">
                      <label htmlFor="followers">Followers</label>
                      <input
                        type="text"
                        name="followers"
                        placeholder="Followers"
                        value={research.followers}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="input-container">
                      <label htmlFor="technologydetails">
                        Technology Details
                      </label>
                      <input
                        type="text"
                        name="technologydetails"
                        placeholder="Technology details"
                        value={research.technologydetails}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="input-container-flex">
                    <div className="input-container">
                      <label htmlFor="jobopenings">Job Openings</label>
                      {research?.jobopenings?.map((job, index) => (
                        <div
                          key={index}
                          className="input-container-flex"
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "3px",
                          }}
                        >
                          <br />
                          <input
                            type="text"
                            name="jobname"
                            placeholder="Job Title"
                            value={job.jobname}
                            onChange={(e) =>
                              handleJobChange(e, index, "jobname")
                            }
                          />
                          <input
                            type="text"
                            name="jobdescription"
                            placeholder="Job Description"
                            value={job.jobdescription}
                            onChange={(e) =>
                              handleJobChange(e, index, "jobdescription")
                            }
                          />
                          <input
                            type="text"
                            name="jobsource"
                            placeholder="Job Link"
                            value={job.jobsource}
                            onChange={(e) =>
                              handleJobChange(e, index, "jobsource")
                            }
                          />
                        </div>
                      ))}
                      <button
                        type="button"
                        className="add-more-field"
                        onClick={addJobOpening}
                      >
                        + Add More
                      </button>
                    </div>
                    <div className="input-container">
                      <label htmlFor="newsandsocialinsights">
                        News and Social Insights
                      </label>
                      {research?.newsandsocialinsights?.map((news, index) => (
                        <div
                          key={index}
                          className="input-container-flex"
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "3px",
                          }}
                        >
                          <br />
                          <input
                            type="text"
                            name="newsname"
                            placeholder="News Title"
                            value={news.newsname}
                            onChange={(e) =>
                              handleNewsChange(e, index, "newsname")
                            }
                          />
                          <input
                            type="text"
                            name="newsdescription"
                            placeholder="News Description"
                            value={news.newsdescription}
                            onChange={(e) =>
                              handleNewsChange(e, index, "newsdescription")
                            }
                          />
                          <input
                            type="text"
                            name="newssource"
                            placeholder="News Source"
                            value={news.newssource}
                            onChange={(e) =>
                              handleNewsChange(e, index, "newssource")
                            }
                          />
                        </div>
                      ))}
                      <button
                        type="button"
                        className="add-more-field"
                        onClick={addNews}
                      >
                        + Add More
                      </button>
                    </div>
                  </div>

                  {/* Input for field label (only shows when Add Field is clicked) */}
                  {showLabelInput && (
                    <div className="input-container">
                      <input
                        type="text"
                        placeholder="Enter Field Label"
                        value={newFieldLabel}
                        onChange={(e) => setNewFieldLabel(e.target.value)}
                        onKeyDown={handleLabelSubmit}
                        autoFocus
                      />
                    </div>
                  )}
                  {research.extraFields?.length > 0 &&
                    research.extraFields.map((field, index) => (
                      <div key={index}>
                        {/* <button onClick={() => handleRemoveField(index)}>X</button> */}
                        <label>{field.label}</label>
                        <input
                          type="text"
                          value={field.value || ""}
                          onChange={(e) => handleFieldValueChange(e, index)}
                        />
                      </div>
                    ))}

                  <div className="button-action">
                    {role === "user" && (
                      <button
                        className="add-field"
                        type="button"
                        onClick={() => setShowLabelInput(true)}
                      >
                        Add Field
                      </button>
                    )}
                    <button className="add-button" type="submit">
                      {role === "researcher"
                        ? "Submit"
                        : role === "admin"
                        ? "Approve"
                        : "Send"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}

          {isOpenListProfile && selectedItem && (
            <div className="profile-popup">
              <div
                className="overlay"
                onClick={() => setIsOpenListProfile(false)}
              ></div>
              <div className="profile-popup-box">
                <div className="profile-box">
                  <div className="profile-container">
                    <div className="dwld-heart"></div>
                    <div className="profile-image">
                      <div className="profile-image-tick">
                        {selectedItem.profileImage ? (
                          <img src={EmptyImage} alt="Profile" />
                        ) : (
                          <img src={EmptyImage} alt="default pic" />
                        )}
                        {visibleColumns.image && visibleColumns.status && (
                          <span className="active-icon">
                            {selectedItem.status === "Active" ? (
                              <VscPass
                                className={getStatusprofile(
                                  selectedItem.status
                                )}
                              />
                            ) : (
                              <VscError
                                className={getStatusprofile(
                                  selectedItem.status
                                )}
                              />
                            )}
                          </span>
                        )}
                      </div>
                    </div>
                    <div
                      className="dwld-btn"
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "start",
                        gap: "25px",
                        marginLeft: "0",
                        marginRight: "40px",
                      }}
                    >
                      <button
                        onClick={() =>
                          handleOpenListEmailCampaign(
                            selectedListName,
                            selectedItem._id
                          )
                        }
                      >
                        <img src={mail} alt="mail" width="25px" />
                      </button>
                      <button onClick={() => downloadListPDF(selectedItem)}>
                        <img src={download} alt="download" width="25px" />
                      </button>
                      <button onClick={handleCloseProfile}>
                        <img
                          src={cross}
                          alt="cross"
                          width="25px"
                          height="25px"
                        />
                      </button>
                    </div>
                  </div>
                  <div className="profile-name">
                    {visibleColumns.firstname && (
                      <p style={{ textAlign: "center", marginRight: "35px" }}>
                        {selectedItem.firstname}
                      </p>
                    )}
                  </div>
                  <div className="profile-role">
                    {visibleColumns.designation && (
                      <p style={{ textAlign: "center" }}>
                        {selectedItem.designation}
                        <span> @ {selectedItem.companyname}</span>
                      </p>
                    )}
                  </div>
                </div>
                <img src={line} alt="line" style={{ marginLeft: "100px" }} />
                <div className="profile-inside-container">
                  <div className="company-info">
                    <button
                      style={{
                        backgroundColor: companyColor,
                        color: companyColor === "#FCB124" ? "#fff" : "#000000",
                        fontWeight: "500",
                      }}
                      onClick={handleShowCompany}
                    >
                      Company Overview
                    </button>
                  </div>
                  <div className="profile-info">
                    <button
                      style={{
                        backgroundColor: techColor,
                        color: techColor === "#FCB124" ? "#fff" : "#000000",
                      }}
                      onClick={handleShowTechStack}
                    >
                      Technographics
                    </button>
                  </div>
                  <div className="profile-info">
                    <button
                      style={{
                        backgroundColor: contactColor,
                        color: contactColor === "#FCB124" ? "#fff" : "#000000",
                      }}
                      onClick={handleShowContact}
                    >
                      Decision Makers
                    </button>
                  </div>
                </div>
                <div
                  className="profile-inside-container"
                  style={{ marginTop: "20px" }}
                >
                  <div className="openings-info">
                    <button
                      style={{
                        backgroundColor: jobColor,
                        color: jobColor === "#FCB124" ? "#fff" : "#000000",
                      }}
                      onClick={handleShowOpenings}
                    >
                      Job Openings
                    </button>
                  </div>
                  <div className="openings-info">
                    <button
                      style={{
                        backgroundColor: accountColor,
                        color: accountColor === "#FCB124" ? "#fff" : "#000000",
                      }}
                      onClick={handleShowAccount}
                    >
                      News & Social Insights
                    </button>
                  </div>
                </div>
                {showCompany && (
                  <div className="company-details">
                    <div className="company-heading"></div>
                    <div className="company-overview">
                      {selectedItem.companyname && (
                        <li className="info-row">
                          <span className="label">
                            🏢 <strong>Company Name</strong>
                            {""}
                          </span>
                          <span className="colon">:</span>
                          <span className="value">
                            {selectedItem.companyname}
                          </span>
                        </li>
                      )}
                      {selectedItem.companydescription && (
                        <li className="info-row">
                          <span className="label">
                            {" "}
                            🏢 <strong>Description</strong>{" "}
                          </span>
                          <span className="colon">:</span>
                          <span className="value">
                            {" "}
                            {selectedItem.companydescription
                              .split(" ")
                              .slice(0, 20)
                              .join(" ")}
                            {selectedItem.companydescription.split(" ").length >
                              50 && "..."}
                          </span>
                        </li>
                      )}
                      {selectedItem.website && (
                        <li className="info-row">
                          <span className="label">
                            {" "}
                            🌐 <strong>Website </strong>
                          </span>
                          <span className="colon">:</span>
                          <span className="value">
                            {" "}
                            <a
                              href={selectedItem.website}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {selectedItem.website}
                            </a>
                          </span>
                        </li>
                      )}
                      {selectedItem.headquarter && (
                        <li className="info-row">
                          <span className="label">
                            📍 <strong>Headquarters</strong>{" "}
                          </span>
                          <span className="colon">:</span>
                          <span className="value">
                            {selectedItem.headquarter}
                          </span>
                        </li>
                      )}
                      {selectedItem.industry && (
                        <li className="info-row">
                          <span className="label">
                            🏭 <strong>Industry</strong>
                          </span>
                          <span className="colon">:</span>
                          <span className="value">
                            {" "}
                            {selectedItem.industry}
                          </span>
                        </li>
                      )}
                      {selectedItem.noofemployees && (
                        <li className="info-row">
                          <span className="label">
                            👥 <strong>Employees</strong>
                          </span>
                          <span className="colon">:</span>
                          <span className="value">
                            {" "}
                            {selectedItem.noofemployees}
                          </span>
                        </li>
                      )}

                      {selectedItem.annualrevenue && (
                        <li className="info-row">
                          <span className="label">
                            {" "}
                            💰 <strong>Revenue</strong>{" "}
                          </span>
                          <span className="colon">:</span>
                          <span className="value">
                            {" "}
                            {selectedItem.annualrevenue}
                          </span>
                        </li>
                      )}
                    </div>
                  </div>
                )}

                {showTechstack && (
                  <div>
                    <div className="tech-heading">
                      <h3>💻Technology Details</h3>
                    </div>
                    <div
                      className="tech-overview"
                      style={{
                        textAlign: "justify",
                        lineHeight: "20px",
                        width: "580px",
                        marginLeft: "80px",
                      }}
                    >
                      {selectedItem.technologydetails && (
                        <span className="tech-text">
                          {selectedItem.technologydetails}
                        </span>
                      )}
                    </div>
                  </div>
                )}

                {showContact && (
                  <div className="company-details">
                    <div className="company-heading">
                      <h3 style={{ marginLeft: "216px", marginTop: "15px" }}>
                        {/* <img src={key} alt="key" width="15px" height="15px" style={{paddingTop:"5px"}} /> */}
                        <FaUserTie /> <strong>Key Decision Makers</strong>
                      </h3>
                    </div>
                    <div
                      className="company-overview"
                      style={{ marginLeft: "150px", lineHeight: "20px" }}
                    >
                      {(() => {
                        // First filter only by company name
                        const sameCompany = data.filter(
                          (contact) =>
                            contact.companyname === selectedItem.companyname
                        );

                        const decisionMakers = sameCompany.filter((contact) =>
                          [
                            "chief executive officer",
                            "ceo",
                            "chief financial officer",
                            "cfo",
                            "cto",
                            "cmo",
                            "chief technology officer",
                            "vp engineering",
                          ].includes(contact.designation?.toLowerCase())
                        );

                        return decisionMakers.length > 0 ? (
                          decisionMakers.map((contact, index) => (
                            <li style={{ marginLeft: "50px" }} key={index}>
                              <FaUserTie /> {contact.firstname} -{" "}
                              {contact.designation}
                            </li>
                          ))
                        ) : (
                          <p style={{ marginLeft: "170px" }}>Not Available</p>
                        );
                      })()}
                    </div>
                  </div>
                )}

                {showAccount && (
                  <div className="company-details">
                    <div className="company-heading">
                      <h3 style={{ marginLeft: "216px" }}>
                        📰 News & Social Insights
                      </h3>
                    </div>
                    <div
                      style={{
                        marginLeft: "30px",
                        lineHeight: "20px",
                        marginTop: "0",
                      }}
                    >
                      {selectedItem.newsandsocialinsights.length === 0 ? (
                        <div>
                          <span>No News available</span>
                        </div>
                      ) : (
                        selectedItem.newsandsocialinsights?.map(
                          (news, index) => {
                            const isExpandedNews = expandedNewsIndex === index;

                            // Truncate description if not expanded
                            const displayText = isExpandedNews
                              ? news.newsdescription
                              : news.newsdescription.slice(0, 150) + "...";
                            return (
                              <div
                                style={{ padding: "5px" }}
                                className="news-item"
                                key={index}
                              >
                                <h4 style={{ fontSize: "14px", margin: "0px" }}>
                                  {news.newsname}
                                </h4>
                                <p
                                  style={{
                                    fontSize: "14px",
                                    width: "550px",
                                    lineHeight: "20px",
                                    textAlign: "justify",
                                  }}
                                >
                                  {displayText}
                                  {news.newsdescription.length > 100 && (
                                    <span
                                      style={{
                                        color: "blue",
                                        cursor: "pointer",
                                      }}
                                      onClick={() =>
                                        setExpandedNewsIndex(
                                          isExpandedNews ? null : index
                                        )
                                      }
                                    >
                                      {isExpandedNews
                                        ? "Read Less"
                                        : "Read More"}
                                    </span>
                                  )}
                                </p>
                                <p
                                  style={{
                                    fontSize: "12px",
                                    marginLeft: "0px",
                                    marginTop: "0",
                                  }}
                                >
                                  Updated:{" "}
                                  {new Date(
                                    selectedItem.createdAt
                                  ).toLocaleDateString()}
                                  &nbsp;{"|"}&nbsp;
                                  {new Date(
                                    selectedItem.createdAt
                                  ).toLocaleTimeString()}
                                  <span
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    {news.newssource}
                                  </span>
                                </p>
                              </div>
                            );
                          }
                        )
                      )}

                      {selectedItem.newsandsocialinsights.length > 1 && (
                        <button
                          style={{
                            backgroundColor: "#FCB124",
                            border: "none",
                            width: "150px",
                            height: "30px",
                            margin: "auto",
                            top: "20px",
                          }}
                          className="show-more-btn"
                          onClick={handleShowMoreNews}
                        >
                          Show More News
                        </button>
                      )}
                    </div>
                  </div>
                )}

                {showOpenings && (
                  <div style={{ paddingBottom: "30px" }}>
                    <div className="company-heading">
                      <h3 style={{ textAlign: "center", marginTop: "30px" }}>
                        {/* <img src={job} alt="job" width="15px" height="15px" style={{paddingTop:"10px"}}/>  */}
                        <FaClipboardList /> <strong>Job Openings</strong>{" "}
                      </h3>
                    </div>
                    {selectedItem.jobopenings.length === 0 ? (
                      <div>
                        <span>No Jobs available</span>
                      </div>
                    ) : (
                      selectedItem.jobopenings.map((job, index) => {
                        const isExpandedJob = expandedJobIndex === index;

                        const displayText = isExpandedJob
                          ? job.jobdescription
                          : job.jobdescription.slice(0, 150) + "...";
                        return (
                          <div className="job-details">
                            <div
                              className="job-container"
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "start",
                                justifyContent: "space-between",
                                gap: "10px",
                              }}
                            >
                              <div key={index}>
                                {job.jobname && (
                                  <h3
                                    className="job-title"
                                    style={{ fontWeight: "400" }}
                                  >
                                    {job.jobname}
                                  </h3>
                                )}
                                {job.jobdescription && (
                                  <p className="company-name">
                                    🏢 {displayText}
                                    {job.jobdescription.length > 100 && (
                                      <span
                                        style={{
                                          color: "blue",
                                          cursor: "pointer",
                                        }}
                                        onClick={() =>
                                          setExpandedJobIndex(
                                            isExpandedJob ? null : index
                                          )
                                        }
                                      >
                                        {isExpandedJob
                                          ? "Read Less"
                                          : "Read More"}
                                      </span>
                                    )}
                                  </p>
                                )}
                              </div>
                              <div>
                                {job.jobsource && (
                                  <p
                                    className="company-location"
                                    style={{ color: "#000", cursor: "pointer" }}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    {" "}
                                    <a
                                      href={job?.jobsource}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <IoMdLink
                                        style={{
                                          fontSize: "25px",
                                          color: "#000",
                                        }}
                                      />
                                    </a>
                                  </p>
                                )}
                              </div>
                            </div>
                          </div>
                        );
                      })
                    )}
                    {selectedItem.jobopenings.length > 3 && (
                      <div
                        className="show-more"
                        style={{ textAlign: "center" }}
                      >
                        <a href="#s">show more</a>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          )}

          {showlist && (
            <div className="popup-overlay">
              <div className="popup-box">
                <h2>Create List</h2>
                <input
                  className="create-input"
                  type="text"
                  value={listName}
                  onChange={(e) => setListName(e.target.value)}
                  placeholder="Enter list name"
                />
                <button onClick={handleSave} className="create-save-btn">
                  Save
                </button>
                <button
                  onClick={() => setShowlist(false)}
                  className="cancel-btn"
                >
                  Cancel
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default MyList;